import React, { Component } from "react";
import {
    Badge,
    Button,
    Card,
    CardBody,
    Col,
    DropdownItem,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as BB from "../../../../components/BBComponent";
import { timeoutPopup } from "../../../../components/BBComponent";
import Swal from "sweetalert2";
import { checkDocumentAccess, showAccessDeniedAlert, createSecureDownloadLink, getCleanFileName, filterDocumentsByType } from "../../../../utils/DocumentAccessControl";
import { bindActionCreators } from "redux";
import notify from "devextreme/ui/notify";
import * as loadingActions from "../../../../redux/actions/loadingActions";
import ReactHtmlParser from "react-html-parser";
import { store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { CustomCard, LabelGroup } from "../../../../components/custom";
import classNames from "classnames";
import "../../../../scss/_taskDetail.scss";
import TaskTerminationModal from "./modals/termination";
import TaskUpdateDescription from "./modals/updateDescription";
import AddJobModal from "./modals/addJob";
import TakeOverUser from "./modals/takeOverUser";
import ChangeCategoryByTask from "./modals/changeCategoryByTask";
import TaskChangeUrgencyModal from "./modals/urgency";
import AdditionalConfirmationModal from "./modals/additionalConfirmation";
import TaskTransferModal from "./modals/transfer";
import TaskAddWatcher from "./modals/watcher";
import TaskAddDescription from "./modals/addDescription";
import TaskViewDescription from "./modals/viewDescription";
import TaskChangeProcessStatus from "./modals/changeProcessStatus";
import TaskViewForm from "./modals/viewForm";
import AdditionalDescription from "./modals/additionalDescription";
import ReactTooltip from 'react-tooltip';
import TaskViewSheet from "./modals/viewSheet";
import CustomStore from "devextreme/data/custom_store";
import jwt_decode from "jwt-decode";
import axiosObj, { callAPI, callApiGet, callApiPost } from "../../../../components/Axios";
import ExtraInfoModal from "./modals/ExtraInfoModal";


import { data } from "jquery";
import "devextreme/integration/jquery";

class TaskDetail extends Component {
    constructor(props) {
        super(props);

        let user = null;
        var token = localStorage.getItem("token");

        if (token) {
            user = jwt_decode(token);
        }


        this.state = {
            data: [],
            status: [],
            customFormData: [],
            customSheetData: [],
            taskLog: [],
            taskLogDescription: [],
            categoryHistory: [],
            uatApprovalHistory: [],
            userList: [],
            taskID: this.props.location.state
                ? this.props.location.state.taskID
                : this.props.location.search
                    ? this.props.location.search.toString().replace("?", "")
                    : null,
            redirect: this.props.location.state
                ? this.props.location.state.taskID
                : this.props.location.search
                    ? false
                    : true,
            taskNumber: "",
            visibleAciklamaGüncelle: false,
            visibleAciliyet: false,
            selectedCompanyUserID: undefined,
            selectedAdditionalConfirmationDescription: "",
            selectedCategoryID: undefined,
            visibleSonlandir: false,
            visibleDevret: false,
            visibleAciklamaEkle: false,
            visibleDurumDegistir: false,
            visibleAdditionalConfirmation: false,
            selectedOverUserId: undefined,
            visiblePoolUser: false,
            ComponentFileUpload: [],
            selectedDegreeOfUrency: 0,
            selectedDegreeOfUrencyDesc: "",
            selectedTerminationType: undefined,
            selectedTerminationTemplate: "",
            selectedTerminationFile: [],
            selectedPoolDevret: null,
            selectedDescriptionDevret: "",
            selectedCommentFiles: [],
            selectedCommentDescription: "",
            selectedShareOwner: false,
            selectedShareOther: false,
            selectedShareOtherMails: [],
            selectedCustomControl: [],
            selectedStatus: "",
            poolUsers: [],
            selectedTaskFiles: [],
            customElements: null,
            selectedPoolUserID: null,
            NotifyDepartment: false,
            visibleDescription: false,
            selectedDescription: "",
            sonlandirStatus: false,
            changeStatus: null,
            selectedEndDate: new Date(),
            selectedLastStatus: null,
            selectedTimed: false,
            following: 0,
            iconVisible: "none",
            myJobs: [],
            jobsLoaded: false,
            tabCounts: {
                jobs: 0,
                recentlyViewed: 0,
                watchers: 0,
                forms: 0,
                sheets: 0,
                extraInfo: 0,
            },
            jobStatus: [],
            selectedProjectNumber: "",
            selectedIsUatApproved: false,
            uatApprovalSaving: false,
            isLastUser: "block",
            additionalConfirmationVisibleToolbar: false,
            previewVisible: false,
            answer_data: [],
            selectedForm: [],
            selectedFormName: undefined,
            selectedFormID: undefined,
            changeCategoryModalVisible: false,
            selectedCompanyUserID: undefined,
            companyUser: [],
            preview2Visible: false,
            rows: [],
            selectedSheet: [],
            selectedSheetName: undefined,
            selectedSheetID: undefined,
            WatcherUsers: [],
            watcherUsersLoaded: false,
            visibleWatcher: false,
            visibleJob: false,
            selectedWatcherUsers: [],
            activeTab: "1",
            selectedTerminationDescription: "",
            recentlyViewed: [],
            recentlyViewedLoaded: false,
            terminationStatus: [],
            terminateTemplate: [],
            customElementItemsDatas: "",
            denemeDropdown: [],
            loginUser: user,
            zorunluOlan: [],
            taskCreator: false,
            sla: 0,
            fileUploaderVisible: "none",
            poolUsers2: [],
            selectedUserId: undefined,
            takeOverUserVisible: false,
            selectedMessage: "",
            companies: [],
            selectedCompanyID: undefined,
            selectedParentCategory: undefined,
            selectedChildCategory1: undefined,
            selectedChildCategory2: undefined,
            selectedChildCategory3: undefined,
            selectedChildCategory4: undefined,
            selectedChildCategory5: undefined,
            selectedChildCategory6: undefined,
            taskCategories: [],
            selectedCategoryName: undefined,
            selectCategory: false,
            childCategory1Arr: [],
            childCategory2Arr: [],
            childCategory3Arr: [],
            childCategory4Arr: [],
            childCategory5Arr: [],
            childCategory6Arr: [],
            categoryPath: "",
            selectedCategory: undefined,
            iconCategoryVisible: "none",
            additionalUsersForTask: [],
            updatedDescription: "",
            updateViewClient: false,
            selectedTaskLogId: undefined,
            updatedTaskDocuments: [],
            tempViewClient: false,
            taskDescDocumentsName: [],
            taskDescDocuments: [],
            deletedDocuments: [],
            updateDescriptionButtonVis: "none",
            companySelectTool: "",
            companySelectToolListVisible: false,
            taskCompaniesTemp: [],
            effor: "",
            additionalDescriptionValue: "",
            visibleAdditionalDescription: false,
            languagesArr: [],
            customFormLoaded: false,
            customSheetLoaded: false,
            selectedWatcherGroups: [],
            watcherList: [],
            selectedWatcherUserID: [],
            selectedWatcherUserList: [],
            oldGroupUsers: [],
            selectedWatcherGroupsID: [],
            isMobile: window.innerWidth <= 768,
            warningAcceptedTaskIDs: [],
            activeJob: null,
            showActiveJobPopup: false,
            activeJobData: null,
            activeJobPopupConfirmed: false,
            visibleExtraInfo: false,
            extraInfoData: [],
            showExtraInfoModal: false,
            taskDetailLogsSectionExpanded: false,
            taskDetailLogsLoaded: false,
        };

        this.poolUsers2Requested = false;

        this.customElement = React.createRef();
        this.taskDetailLogsAnchorRef = React.createRef();
        let { t } = this.props;



        this.languages = {
            hata: t("hata"),
            onayVer: t("onayVer"),
            iptal: t("iptal"),
            vazgec: t("vazgec"),
            vazgec2: t("talepAciklamasi"),
            devral: t("devral"),
            eminMisiniz: t("eminMisiniz"),
            talepDevralindi: t("talepDevralindi"),
            talebiDevralacaksiniz: t("talebiDevralacaksiniz"),
            onayAciklamasiGiriniz: t("onayAciklamasiGiriniz"),
            iptalAciklamasiGiriniz: t("iptalAciklamasiGiriniz"),
            onayBasariylaVerilmistir: t("onayBasariylaVerilmistir"),
            talepBasariylaIptalEdilmistir: t("talepBasariylaIptalEdilmistir"),
            talepBasariylaDevredildi: t("talepBasariylaDevredildi"),
            havuzAlaniZorunludur: t("havuzAlaniZorunludur"),
            durumAlaniZorunludur: t("durumAlaniZorunludur"),
            talepDurumDegistirmeBasarili: t("talepDurumDegistirmeBasarili"),
            aciklamaAlaniZorunludur: t("aciklamaAlaniZorunludur"),
            dosyaEklemeZorunludur: t("dosyaEklemeZorunludur"),
            hizliTalepOlusturAciklama: t("hizliTalepOlusturAciklama"),
            EkOnay: t("EkOnay"),
            talepBasariylaSonlandirildi: t("talepBasariylaSonlandirildi"),
            sonlandirmaAciklamasiAlaniZorunludur: t(
                "sonlandirmaAciklamasiAlaniZorunludur"
            ),
            talebinAciliyetiBasariylaDegistirildi: t(
                "talebinAciliyetiBasariylaDegistirildi"
            ),
            talebinAciliyetiDegistirilirkenHataAlindi: t(
                "talebinAciliyetiDegistirilirkenHataAlindi"
            ),
            sonlandirmaTuruAlaniZorunludur: t("sonlandirmaTuruAlaniZorunludur"),
            talepDurumuBeklemedeOlanHavuzaGonderilmez: t(
                "talepDurumuBeklemedeOlanHavuzaGonderilmez"
            ),
            ozelAlanZorunlu: t("ozelAlanZorunlu"),
            TalepSorumlusuOlmanızVeyaTalebinOnaySürecininBitmesiGrekmektedir: t("TalepSorumlusuOlmanızVeyaTalebinOnaySürecininBitmesiGrekmektedir"),

            göreveBaslanmıştır: t("göreveBaslanmıştır."),
            görevDurduruldu: t("görevDurduruldu."),
            göreveBaslatılırkenHata: t("göreveBaslatılırkenHata."),
            gorevTamamlanmıstır: t("gorevTamamlanmıstır."),
            goreveTamamlanırkenHata: t("goreveTamamlanırkenHata."),
            lutfenTalebiOnceIslemeAlınız: t("lutfenTalebiOnceIslemeAlınız"),
            onaylıyorMusunuz: t("onaylıyorMusunuz?"),
            kategoriBasarıIleDegistirildi: t("kategoriBasarıIleDegistirildi"),
            kategoriOnayaAlindiDurumMesaji: t("kategoriOnayaAlindiDurumMesaji"),
            talepSahibininYöneticisiBosOlamaz: t("talepSahibininYöneticisiBosOlamaz"),
            kategoriDegistirilemedi: t("kategoriDegistirilemedi"),
            sonlandırılmısBirTalebinKategorisiDegistirilemez: t("sonlandırılmısBirTalebinKategorisiDegistirilemez."),
            secmisOldugunuzKategoriTalebinKategorisiIleAynıdır: t("secmisOldugunuzKategoriTalebinKategorisiIleAynıdır"),
            secmisOldugunuzKategorininOnaySeviyesiMevcutKategoridenFarklıdırLutfenIptalEdipTekrarTalepAcınız: t("secmisOldugunuzKategorininOnaySeviyesiMevcutKategoridenFarklıdırLutfenIptalEdipTekrarTalepAcınız"),
            gorevIptalEdilirkenHata: t("gorevIptalEdilirkenHata!!!"),
            sonlandırılmısBirTalebinSorumlusuDegistirilemez: t("sonlandırılmısBirTalebinSorumlusuDegistirilemez."),
            talepDevredilirkenHata: t("talepDevredilirkenHata!!!"),
            gorevAtanamadı: t("gorevAtanamadı"),
            talepDahaOnceOnaylanmıştır: t("talepDahaOnceOnaylanmıştır"),
            evet: t("evet"),
            hayır: t("hayır"),
            talebintakibibırakılacaktır: t("talebintakibibırakılacaktır"),
            Görev: t("Görev"),
            redAcıklamasıGiriniz: t("redAcıklamasıGiriniz"),
            dahaOnceBuTalebiSizdenOnceBirKullanıcıÜzerineAlmışVeyaİslemYapmışBuTalepUzerindeIslemYapamazsınız: t("dahaOnceBuTalebiSizdenOnceBirKullanıcıÜzerineAlmışVeyaİslemYapmış.BuTalepUzerindeIslemYapamazsınız!"),
            talepIslemDurumuTalebiKapatmayaUygunDegilOncelikleIslemeAlınız: t("talepIslemDurumuTalebiKapatmayaUygunDegil,OncelikleIslemeAlınız"),
            durumDegistir: t("durumDegistir"),
            formGoruntule: t("formGoruntule"),
            dahaOncekiBirZamanSecemezsiniz: t("dahaOncekiBirZamanSecemezsiniz"),
            talepTakibiBasarılı: t("talepTakibiBasarılı"),
            eforKaydınıSadeceTalepSorumlusuGüncelleyebilir: t("eforKaydınıSadeceTalepSorumlusuGüncelleyebilir."),
            Görevbaşarıylasilindi: t("Görevbaşarıylasilindi"),
            göreviptaledilirkenhata: t("göreviptaledilirkenhata"),
            talebbasarıiledevredildi: t("talebbasarıiledevredildi"),
            Görevbaşarıylaatandı: t("Görevbaşarıylaatandı"),
            görevatanamadi: t("görevatanamadi"),
            redded: t("redded"),
            talepdahaöncereddedilmiştir: t("talepdahaöncereddedilmiştir"),
            tamam: t("tamam"),
            talepdevralınmış: t("talepdevralınmış"),
            talebdahaöncesindeişlemealımıs: t("talebdahaöncesindeişlemealımıs"),
            TalepişlemdurumutalebikapatmayauygundeğilÖncelikleİşlemeAlınız: t("TalepişlemdurumutalebikapatmayauygundeğilÖncelikleİşlemeAlınız"),
            Dahaöncekibirzamanseçemezsiniz: t("Dahaöncekibirzamanseçemezsiniz"),
            görevatanamadi: t("görevatanamadi"),
            Dahaöncekibirzamanseçemezsiniz: t("Dahaöncekibirzamanseçemezsiniz"),
            eforKaydınıSadeceTalepSorumlusuGüncelleyebilir: t("eforKaydınıSadeceTalepSorumlusuGüncelleyebilir."),
            eforKaydınıSadeceTalepSorumlusuGüncelleyebilir: t("eforKaydınıSadeceTalepSorumlusuGüncelleyebilir."),
            basarili: t("Basarılı!"),
            birHataAlındı: t("birHataAlındı!"),
            DTiçinUygunKategorilerSeciliDegildir: t("DTiçinUygunKategorilerSeciliDegildir."),
            buTalepicinÖncedenOluşturulmuşBirAzureKaydıMevcuttur: t("buTalepicinÖncedenOluşturulmuşBirAzureKaydıMevcuttur."),
            projeNumarasıAlanınıSadeceTalepSorumlusuDegistirebilir: t("projeNumarasıAlanınıSadeceTalepSorumlusuDegistirebilir!"),
            EkOnayaGönder: t("EkOnayaGönder"),
            izleyiciEkle: t("izleyiciEkle"),
            izleyici: t("izleyici"),
            GörevEkle: t("GörevEkle"),
            yukleniyor: t("yukleniyor"),
            talepAynıKisiyeDevirEdilemez: t("talepAynıKisiyeDevirEdilemez")
        };

        this._isMounted = false;
    }

    safeSetState = (updater, callback) => {
        if (!this._isMounted) return;
        this.setState(updater, callback);
    };

    handleResize = () => {
        this.safeSetState({
            isMobile: window.innerWidth <= 768  // Eğer ekran genişliği 768'den küçükse mobil olarak kabul et
        });
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.getData(nextProps.location.search.slice(1));
        }
    }

    GetWatcherGroups() {
        callAPI(
            callApiGet,
            `api/User/GetWatcherGroupsByUserId`,
            {},
            async (res) => {
                if (res?.data) {
                    this.setState({
                        oldGroupUsers: res?.data
                    });
                }
            },
            true
        );
    }

    ///api/User/GetUserList

    GetAllUsersForWatcher() {
        callAPI(
            callApiGet,
            `api/User/GetUserList`,
            {},
            async (res) => {
                if (res?.data) {
                    this.setState({
                        watcherList: res?.data
                    });
                }
            },
            true
        );
    }

    GetWatcherGroupUsers(group) {
        callAPI(
            callApiGet,
            `api/User/GetGroupUsersByGroupId`,
            { watchersGroupID: JSON.stringify(group) },
            async (res) => {
                if (res?.data != null) {
                    this.setState({ selectedWatcherGroups: res?.data });
                }
            },
            true
        );
    }

    componentDidMount() {
        this._isMounted = true;
        this.getAdditionalConfirmationUsers(this.state.taskID);
        this.checkIsLastUser();
        const taskID = this.props.location.search.replace("?", "");
        this.GetTaskDetailTabCounts(taskID || this.state.taskID);
        this.getData(taskID);
        //await this.GetCompanyUsers(this.state.taskID);
        //this.GetCustomForm(this.state.taskID);

        this.renderActionButtons();
        //this.GetSlaMinuteByTaskNumber(this.state.data);
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidUpdate(prevProps, prevState) {
        // TaskID değiştiyse yeniden yükle
        if (prevState.taskID !== this.state.taskID) {
            // Yeni talebe geçildiğinde tekrar havuz kullanıcılarını alalım.
            this.poolUsers2Requested = false;
            this.setState({
                watcherUsersLoaded: false,
                WatcherUsers: [],
                jobsLoaded: false,
                myJobs: [],
                recentlyViewedLoaded: false,
                recentlyViewed: [],
                tabCounts: { jobs: 0, recentlyViewed: 0, watchers: 0, forms: 0, sheets: 0, extraInfo: 0 },
            });
            this.getAdditionalConfirmationUsers(this.state.taskID);
            this.checkIsLastUser();
            this.GetTaskDetailTabCounts(this.state.taskID);
            this.getData();
            this.renderActionButtons();
        }
    }

    changeTab = (tabId) => {
        this.setState({ activeTab: tabId }, () => {
            if ((tabId === "1" || tabId === "2" || tabId === "6") && !this.state.taskDetailLogsLoaded) {
                this.expandTaskDetailLogs({
                    forceReload: false,
                    scrollIntoView: false,
                });
            }
            if (tabId === "3" && !this.state.jobsLoaded) {
                this.GetMyJobs(this.state.taskID || this.state.data?.ID);
            }
            if (tabId === "4") {
                const currentTaskID = this.state.taskID || this.state.data?.ID;
                if (!this.state.recentlyViewedLoaded) {
                    this.GetRecentlyViewed(currentTaskID);
                    // Aynı task için ilk yüklemede bir kez kaydet.
                    this.AddRecentlyViewed(currentTaskID);
                }
            }
            if (tabId === "5" && !this.state.watcherUsersLoaded) {
                this.GetWatcherUsers(this.state.taskID || this.state.data?.ID);
            }
        });
    };

    mergeTaskDetailUiPatch(target, patch) {
        if (!patch) return target || {};
        const base = { ...(target || {}) };
        const isTrivialCreateDate = (val) => {
            if (val == null) return true;
            const d = val instanceof Date ? val : new Date(val);
            if (Number.isNaN(d.getTime())) return true;
            return d.getUTCFullYear() < 1900;
        };
        for (const key of Object.keys(patch)) {
            const v = patch[key];
            if (v === null || v === undefined) continue;
            if (Array.isArray(v) && v.length === 0) continue;
            if (typeof v === "string" && v === "") continue;
            if (
                (key === "createDate" || key === "CreateDate") &&
                isTrivialCreateDate(v)
            ) {
                continue;
            }
            if (
                (key === "taskNumber" || key === "TaskNumber") &&
                (v === 0 || v === "0")
            ) {
                continue;
            }
            base[key] = v;
        }
        return base;
    }

    /**
     * GetTaskDetailUiTaskLogs: TaskDetailUiTaskLogsDto veya geriye dönük düz dizi / TaskLog.
     */
    parseTaskDetailUiTaskLogsResponse(raw) {
        if (raw == null || raw.IsAccessDenied) {
            return { taskLogs: [], categoryHistory: [], uatApprovalHistory: [] };
        }
        if (Array.isArray(raw)) {
            return { taskLogs: raw, categoryHistory: [], uatApprovalHistory: [] };
        }
        const ch = raw.CategoryHistory ?? raw.categoryHistory;
        const categoryHistory = Array.isArray(ch) ? ch : [];
        const uah = raw.UatApprovalHistory ?? raw.uatApprovalHistory;
        const uatApprovalHistory = Array.isArray(uah) ? uah : [];
        const tl = raw.TaskLogs ?? raw.taskLogs ?? raw.TaskLog ?? raw.taskLog;
        if (Array.isArray(tl)) {
            return { taskLogs: tl, categoryHistory, uatApprovalHistory };
        }
        return { taskLogs: [], categoryHistory, uatApprovalHistory };
    }

    getTaskCreateDateRaw() {
        const d = this.state.data;
        if (!d) return null;
        return d.CreateDate != null ? d.CreateDate : d.createDate;
    }

    applyTaskSplitFromTaskLog(data, taskLogList) {
        const normGuid = (g) => (g == null || g === "" ? "" : String(g).toLowerCase());
        const meID = normGuid(this.state.loginUser?.ID ?? this.state.loginUser?.id);
        const all = taskLogList || [];
        const logTypeNum = (x) => Number(x?.LogType);
        const ownerID = normGuid(data?.CreateUserID ?? data?.createUserID);
        const ownerUserID = normGuid(data?.OwnerUserID ?? data?.ownerUserID);
        const isMyTasks = ownerID !== "" && ownerID === meID;
        const poolID = normGuid(data?.PoolID ?? data?.poolID);
        const viewerPools = data?.ViewerUserPool ?? data?.viewerUserPool ?? [];
        const responsibleID = normGuid(data?.ResponsibleUserID ?? data?.responsibleUserID);
        const isPoolHandler =
            (responsibleID !== "" && responsibleID === meID) ||
            (poolID !== "" &&
                Array.isArray(viewerPools) &&
                viewerPools.some((p) => normGuid(p) === poolID));

        let descrtiption = [];
        if (isMyTasks && !isPoolHandler) {
            descrtiption = all.filter(
                (x) =>
                    logTypeNum(x) === 1 &&
                    (normGuid(x.TargetUserID) === meID ||
                        normGuid(x.CreateUserID) === meID ||
                        x.ViewClient === true ||
                        (ownerID !== "" && normGuid(x.CreateUserID) === ownerID) ||
                        (ownerUserID !== "" && normGuid(x.CreateUserID) === ownerUserID))
            );
        } else {
            descrtiption = all.filter((x) => logTypeNum(x) === 1);
        }
        const otherLogs = all.filter((x) => logTypeNum(x) !== 1);
        return { taskLogDescription: descrtiption, taskLog: otherLogs };
    }

    getCategoryHistoryRows = () => this.state.categoryHistory || [];

    getUatApprovalHistoryRows = () => this.state.uatApprovalHistory || [];

    getHistoryTabCount = () =>
        this.getCategoryHistoryRows().length + this.getUatApprovalHistoryRows().length;

    expandTaskDetailLogs = (options = {}) => {
        const { forceReload = false, scrollIntoView = true } = options;
        const taskID = this.state.taskID;
        if (!taskID) return;
        if (this.state.taskDetailLogsLoaded && !forceReload) {
            this.setState(
                { taskDetailLogsSectionExpanded: true },
                () => {
                    if (scrollIntoView && this.taskDetailLogsAnchorRef.current) {
                        this.taskDetailLogsAnchorRef.current.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    }
                }
            );
            return;
        }
        const headers = { headers: { "Accept-Version": "v1" } };
        this.props.actions.isLoading(true);
        (async () => {
            try {
                const r = await axiosObj.get(
                    "api/TaskDetail/GetTaskDetailUiTaskLogs?ID=" + taskID,
                    headers
                );
                const raw = r.data;
                if (raw?.IsAccessDenied) return;
                const parsed = this.parseTaskDetailUiTaskLogsResponse(raw);
                const logArr = parsed.taskLogs;
                const merged = this.mergeTaskDetailUiPatch(this.state.data, {
                    TaskLog: logArr,
                });
                const all = merged.TaskLog || [];
                const split = this.applyTaskSplitFromTaskLog(merged, all);
                this.safeSetState(
                    {
                        data: merged,
                        taskLog: split.taskLog,
                        taskLogDescription: split.taskLogDescription,
                        categoryHistory: parsed.categoryHistory,
                        uatApprovalHistory: parsed.uatApprovalHistory,
                        taskDetailLogsSectionExpanded: true,
                        taskDetailLogsLoaded: true,
                    },
                    () => {
                        if (scrollIntoView && this.taskDetailLogsAnchorRef.current) {
                            this.taskDetailLogsAnchorRef.current.scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                            });
                        }
                    }
                );
            } catch (e) {
                console.error("GetTaskDetailUiTaskLogs", e);
                notify(
                    e?.response?.data?.Message ||
                        e?.response?.data?.message ||
                        e?.message ||
                        "Tarihçe yüklenirken bir hata oluştu.",
                    "error",
                    4000
                );
            } finally {
                this.props.actions.isLoading(false);
            }
        })();
    };

    collapseTaskDetailLogs = () => {
        this.setState({
            taskDetailLogsSectionExpanded: false,
        });
    };

    getData(TaskID) {
        const explicitTaskArg = TaskID !== undefined;
        const shouldRefreshLogs = !explicitTaskArg;
        let taskID = TaskID !== undefined ? TaskID : this.state.taskID;

        this.props.actions.isLoading(true);

        this.props.history.push("/TaskDetail?" + taskID);

        this.isOwnTask = this.props.location.state
            ? this.props.location.state.ownTask
            : null;

        const headers = { headers: { "Accept-Version": "v1" } };

        (async () => {
            try {
                const r = await axiosObj.get(
                    "api/TaskDetail/GetTaskDetailUiInitialPage?ID=" + taskID,
                    headers
                );
                const nextMerged = r.data;
                if (!nextMerged || nextMerged.IsAccessDenied) {
                    notify(
                        nextMerged?.AccessDeniedMessage ||
                        "Erişiminiz kısıtlanmıştır",
                        "error",
                        5000
                    );
                    this.props.history.replace("/main");
                    return;
                }

                // TaskLog / kategori tarihçesi: sayfa açılışında yüklenir.
                const mergedWithLogs = nextMerged;
                const split = this.applyTaskSplitFromTaskLog(
                    mergedWithLogs,
                    mergedWithLogs.TaskLog || []
                );

                if (mergedWithLogs.Effort === null) {
                    this.safeSetState({ effor: 0 });
                } else {
                    this.safeSetState({ effor: mergedWithLogs.Effort });
                }

                const changeIconVisible =
                    mergedWithLogs.ChangeResponsibleUserVisible === true
                        ? "block"
                        : "none";
                const meID = this.state.loginUser?.ID;
                const taskCreator =
                    mergedWithLogs.TaskCreator === true ||
                    mergedWithLogs.CreateUserID === meID;

                this.safeSetState(
                    (prevState) => {
                        const sameTask = String(prevState.taskID) === String(mergedWithLogs.ID);
                        const keepTaskLogsUi =
                            !shouldRefreshLogs &&
                            sameTask &&
                            prevState.taskDetailLogsLoaded === true;

                        return {
                            data: mergedWithLogs,
                            iconVisible: changeIconVisible,
                            iconCategoryVisible: changeIconVisible,
                            taskID: mergedWithLogs.ID,
                            taskCreator: taskCreator,
                            // Detay bölümü artık her zaman açık.
                            taskLog: keepTaskLogsUi ? prevState.taskLog : split.taskLog,
                            taskLogDescription: keepTaskLogsUi
                                ? prevState.taskLogDescription
                                : split.taskLogDescription,
                            categoryHistory: keepTaskLogsUi ? prevState.categoryHistory : [],
                            uatApprovalHistory: keepTaskLogsUi ? prevState.uatApprovalHistory : [],
                            taskDetailLogsSectionExpanded: true,
                            taskDetailLogsLoaded: keepTaskLogsUi ? true : false,
                            selectedProjectNumber:
                                mergedWithLogs.VstsID && mergedWithLogs.VstsID.trim() !== ""
                                    ? mergedWithLogs.VstsID
                                    : mergedWithLogs.ProjectNumber,
                            vstsid: mergedWithLogs.VstsID,
                            selectedIsUatApproved: mergedWithLogs.IsUatApproved === true,
                            customFormData: sameTask ? prevState.customFormData : [],
                            customSheetData: sameTask ? prevState.customSheetData : [],
                            customFormLoaded: sameTask ? prevState.customFormLoaded : false,
                            customSheetLoaded: sameTask ? prevState.customSheetLoaded : false,
                        };
                    },
                    () => {
                        if (
                            shouldRefreshLogs &&
                            (this.state.activeTab === "1" ||
                                this.state.activeTab === "2" ||
                                this.state.activeTab === "6")
                        ) {
                            this.expandTaskDetailLogs({
                                forceReload: true,
                                scrollIntoView: false,
                            });
                        } else if (this.state.activeTab === "1" && !this.state.taskDetailLogsLoaded) {
                            this.expandTaskDetailLogs({
                                forceReload: false,
                                scrollIntoView: false,
                            });
                        }
                    }
                );

            } catch (e) {
                console.error(e);
                const apiMsg =
                    e?.response?.data?.Message ||
                    e?.response?.data?.message ||
                    (typeof e?.response?.data === "string"
                        ? e.response.data
                        : null);
                notify(
                    apiMsg ||
                    e?.message ||
                    "Talep detayı yüklenirken bir hata oluştu.",
                    "error",
                    5000
                );
                this.props.history.replace("/main");
            } finally {
                this.props.actions.isLoading(false);
            }
        })();
    }

    openExtraInfoModal = async () => {
        const taskID = this.state?.taskID || this.state?.data?.ID;
        const hasCustomValue =
            Array.isArray(this.state?.data?.CustomValue) &&
            this.state.data.CustomValue.length > 0;
        const expectedExtraInfoCount = Number(this.state?.tabCounts?.extraInfo || 0);
        const shouldLoadFromStep4 =
            !taskID || (hasCustomValue || expectedExtraInfoCount <= 0);

        if (shouldLoadFromStep4) {
            this.setState({ showExtraInfoModal: true });
            return;
        }

            this.props.actions.isLoading(true);
        try {
            const headers = { headers: { "Accept-Version": "v1" } };
            const response = await axiosObj.get(
                "api/TaskDetail/GetTaskDetailUiStep4?ID=" + taskID,
                headers
            );
            const step4Data = response?.data || {};

            if (step4Data.IsAccessDenied) {
                notify(
                    step4Data.AccessDeniedMessage || "Erişiminiz kısıtlanmıştır",
                    "error",
                    5000
                );
                return;
            }

            this.safeSetState((prevState) => ({
                showExtraInfoModal: true,
                data: {
                    ...prevState.data,
                    CustomValue: Array.isArray(step4Data.CustomValue)
                        ? step4Data.CustomValue
                        : prevState.data.CustomValue,
                    TaskDocument: Array.isArray(step4Data.TaskDocument)
                        ? step4Data.TaskDocument
                        : prevState.data.TaskDocument,
                },
            }));
        } catch (e) {
            notify(
                e?.response?.data?.Message ||
                e?.message ||
                "Ek bilgiler yüklenirken bir hata oluştu.",
                "error",
                4000
            );
        } finally {
            this.props.actions.isLoading(false);
        }
    };

    checkChangeCategoryAccept = (TaskID, onAllowed) => {
        let url = "/api/TaskDetail/CheckChangeCategoryAccept?TaskID=" + TaskID;

        callAPI(
            callApiGet,
            url,
            {},
            (res) => {
                const visibility = res?.data || "none";
                this.safeSetState({ iconCategoryVisible: visibility });
                if (visibility !== "none" && typeof onAllowed === "function") {
                    onAllowed();
                }
            },
            true
        );
    };
    checkAdditionalUserPermission = () => {
        let url =
            "/api/TaskDetail/CheckAdditionalUserPermission?taskID=" +
            this.state.taskID;
        callAPI(
            callApiGet,
            url,
            {},
            (res) => {
                if (res?.data) {
                    this.setState(
                        { visibleAdditionalConfirmation: true },
                        this.getCompanies()
                    );
                    //this.setState({ additionalConfirmationVisibleToolbar: res?.data })
                } else {
                    notify(
                        this.languages.TalepSorumlusuOlmanızVeyaTalebinOnaySürecininBitmesiGrekmektedir,
                        "error",
                        4000
                    );
                }
            },
            true
        );
    };
    getAdditionalConfirmationUsers = (TaskID) => {
        let url = "/api/TaskDetail/GetAdditionalConfirmationUsers?taskID=" + TaskID;
        callAPI(
            callApiGet,
            url,
            {},
            (res) => {
                if (res?.data) {
                    this.safeSetState({ additionalUsersForTask: res?.data });
                }
            },
            true,
            () => {
                // Endpoint 500 dönse bile sayfa kırılmasın; kullanıcı ekranı kullanmaya devam etsin.
                this.safeSetState({ additionalUsersForTask: [] });
            }
        );
    };
    getCategoriesForChangeCategories = () => {
        let url =
            "/api/TaskDetail/GetCategoriesForChangeCategories?taskID=" +
            this.state.taskID;
        callAPI(
            callApiGet,
            url,
            {},
            (res) => {
                if (res?.data) {
                    this.setState({ taskCategories: res?.data });
                }
            },
            true
        );
    };

    getParentCategories = (TaskID, ParentID) => {
        let url =
            TaskID !== null &&
            "/api/Task/GetCategoriesForChangeTaskCategories?TaskID=" +
            TaskID +
            "&ParentID=" +
            ParentID;

        this.setState({ parentCategoryLoading: true });

        callAPI(
            callApiGet,
            url,
            {},
            async (res) => {
                if (res?.data) {
                    this.setState({
                        taskCategories: res?.data,
                        parentCategoryLoading: false,
                    });

                    this.props.actions.isLoading(false);
                }
            },
            true
        );
    };


    GetSlaMinuteByTaskNumber = (data) =>
        new Promise((resolve) => {
            var url =
                "/api/TaskDetail/GetSlaMinuteByTaskNo?taskNumber=" + data.TaskNumber;
            callAPI(callApiGet, url, {}, async (res) => {
                this.setState({
                    sla: res.data ? res.data : null,
                });
                resolve(true);
            });
        });

    GetCustomElementsForClosing = (data) =>
        new Promise((resolve) => {
            var url =
                "/api/TaskDetail/GetCustomElementsForClosing?id=" + data.CategoryID;
            callAPI(callApiGet, url, {}, async (customElements) => {
                this.setState({
                    customElements: customElements.data ? customElements.data : null,
                });
                resolve(true);
            });
        });

    GetProccessStatus = () =>
        new Promise((resolve) => {
            var url = "api/TaskDetail/GetProccessStatus";
            callAPI(callApiGet, url, {}, async (status) => {
                this.setState({
                    status: status.data,
                });
                resolve(true);
            });
        });

    GetCompanyUsers = (taskID) =>
        new Promise((resolve) => {
            var url = "api/Main/GetCompanyUsers?TaskID=" + taskID;
            callAPI(callApiGet, url, {}, async (poolUsers) => {
                this.setState({
                    poolUsers: poolUsers.data,
                });
                resolve(true);
            });
        });

    GetMyJobs = (taskID) => {
        if (!taskID) {
            this.setState({ myJobs: [], jobsLoaded: false });
            return;
        }
        var url = "api/TaskTracking/GetJobsByTaskID?TaskID=" + taskID;
        callAPI(callApiGet, url, {}, (GetMyJobs) => {
            const list = Array.isArray(GetMyJobs?.data) ? GetMyJobs.data : [];
            this.setState({
                myJobs: list,
                jobsLoaded: true,
                tabCounts: {
                    ...this.state.tabCounts,
                    jobs: list.length,
                },
            });
        });
    };
    confirmActiveJobPopup = () => {
        this.setState(
            {
                showActiveJobPopup: false,
                activeJobPopupConfirmed: true
            },
            () => {
                // Popup sonrası görev başlat
                this.SetStartDate(this.state.pendingStartJobID);
            }
        );
    };

    cancelActiveJobPopup = () => {
        this.setState({
            showActiveJobPopup: false,
            pendingStartJobID: null
        });
    };

    onJobStartClick = (jobID) => {
        const url = "api/TaskTracking/GetActiveJob";

        callAPI(callApiGet, url, {}, (res) => {
            const activeJobs = res.data;

            if (!activeJobs || activeJobs.length === 0) {
                this.SetStartDate(jobID);
                return;
            }
            if (this.state.activeJobPopupConfirmed) {
                this.SetStartDate(jobID);
                return;
            }

            // Henüz TAMAM dememiş → popup aç
            this.openStopPopup(activeJobs, jobID);
        });
    };
    openStopPopup(activeJobs, jobID) {
        const taskListHtml = activeJobs
            .map(x => `
            <a href="/#!/TaskDetail?${x.TaskID}" 
                target="_blank"
                rel="noopener noreferrer">
                ${x.TaskNumber}
            </a>
        `)
            .join(" / ");

        Swal.fire({
            icon: "warning",
            title: "Aktif Göreviniz Var",
            html: `
            <p>Aktif görevleriniz mevcut. Devam etmeden önce açık görevlerinizi kontrol edebilirsiniz.</p>            
            <p style="margin-top:10px;"><b>Talep Numaraları:</b></p>
            ${taskListHtml}
                        
        `,
            showCancelButton: true,
            confirmButtonText: this.languages.tamam,
            cancelButtonText: this.languages.iptal,

        }).then(result => {
            if (result.isConfirmed) {

                this.setState({
                    activeJobPopupConfirmed: true
                });

            }
        });
    }


    StartJob = (jobID) => {
        this.SetStartDate(jobID);
    };
    SetStartDate = (jobID) =>
        new Promise((resolve) => {
            var url = "api/TaskTracking/SetStartDate?jobID=" + jobID;
            callAPI(callApiGet, url, {}, (res) => {
                if (String(res.data) !== "00000000-0000-0000-0000-000000000000") {
                    notify(this.languages.göreveBaslanmıştır, "success", 5000);

                    var url = "api/TaskTracking/GetJobsByTaskID?TaskID=" + res.data;
                    callAPI(callApiGet, url, {}, (GetMyJobs) => {
                        this.setState({
                            myJobs: GetMyJobs.data,
                        });
                        resolve(true);
                    });
                } else {
                    notify(this.languages.göreveBaşlatılırkenHata, "error", 5000);
                }
                resolve(true);
            });
        });
    SetStopDate = (jobID, Description) =>
        new Promise((resolve) => {
            var url = "api/TaskTracking/SetStopDate?jobID=" + jobID + "&Description=" + encodeURIComponent(Description);
            callAPI(callApiGet, url, {}, (res) => {
                console.log("res", res);
                if (String(res.data) !== "00000000-0000-0000-0000-000000000000") {
                    notify(this.languages.görevDurduruldu, "success", 5000);

                    var url = "api/TaskTracking/GetJobsByTaskID?TaskID=" + res.data;
                    callAPI(callApiGet, url, {}, (GetMyJobs) => {
                        this.setState({
                            myJobs: GetMyJobs.data,
                        });
                        resolve(true);
                    });
                } else {
                    notify(this.languages.görevDurdurulurkenHata, "error", 5000);
                }
                resolve(true);
            });
        });

    SetFinishDate = (jobID) =>
        new Promise((resolve) => {
            var url = "api/TaskTracking/SetFinishDate?jobID=" + jobID;
            callAPI(callApiGet, url, {}, (res) => {
                if (String(res.data) !== "00000000-0000-0000-0000-000000000000") {
                    notify(this.languages.gorevTamamlanmıstır, "success", 5000);

                    var url = "api/TaskTracking/GetJobsByTaskID?TaskID=" + res.data;
                    callAPI(callApiGet, url, {}, (GetMyJobs) => {
                        this.setState({
                            myJobs: GetMyJobs.data,
                        });
                        resolve(true);
                    });
                } else {
                    notify(this.languages.goreveTamamlanırkenHata, "error", 5000);
                }
                resolve(true);
            });
        });
    GetCustomForm = (taskID) =>
        new Promise((resolve) => {
            if (!taskID) {
                resolve([]);
                return;
            }
            BB.FetchJSON("/api/TaskDetail/GetCustomForm?TaskID=" + taskID).then(
                (GetCustomForm) => {
                    const formList = Array.isArray(GetCustomForm) ? GetCustomForm : [];
                    this.setState({
                        selectedFormID:
                            formList.length > 0 ? formList[0].FormID : undefined,
                        customFormData: formList.length > 0 ? formList : [],
                        selectedFormName:
                            formList.length > 0 ? formList[0].Name : undefined,
                        answer_data:
                            formList.length > 0
                                ? JSON.parse(formList[0].Values)
                                : undefined,
                        selectedForm:
                            formList.length > 0
                                ? JSON.parse(formList[0].Form).task_data
                                : undefined,
                        previewVisible: false,
                        customFormLoaded: true,
                        tabCounts: {
                            ...this.state.tabCounts,
                            forms: formList.length,
                        },
                    });
                    resolve(formList);
                }
            ).catch(() => {
                this.setState({ customFormLoaded: false });
                resolve([]);
            });
        });

    GetCustomSheet = (taskID) =>
        new Promise((resolve) => {
            if (!taskID) {
                resolve([]);
                return;
            }
            BB.FetchJSON("/api/TaskDetail/GetCustomSheet?TaskID=" + taskID).then(
                (GetCustomSheet) => {
                    const sheetList = Array.isArray(GetCustomSheet) ? GetCustomSheet : [];
                    this.setState({
                        selectedSheetID:
                            sheetList.length > 0 ? sheetList[0].FormID : undefined,
                        customSheetData: sheetList.length > 0 ? sheetList : [],
                        selectedSheetName:
                            sheetList.length > 0 ? sheetList[0].Name : undefined,
                        rows:
                            sheetList.length > 0
                                ? JSON.parse(sheetList[0].Values)
                                : [],
                        selectedSheet:
                            sheetList.length > 0
                                ? JSON.parse(sheetList[0].Form)
                                : undefined,
                        customSheetLoaded: true,
                        tabCounts: {
                            ...this.state.tabCounts,
                            sheets: sheetList.length,
                        },
                    });
                    resolve(sheetList);
                }
            ).catch(() => {
                this.setState({ customSheetLoaded: false });
                resolve([]);
            });
        });
    deleteSelectedFile = (name) => {
        let newFiles = [];
        this.state.selectedTaskFiles.map((item, i) => {
            if (item.name !== name) {
                newFiles.push(item);
            }
        });

        this.setState({ selectedTaskFiles: newFiles });
        this.setState({ ComponentFileUpload: newFiles });
    };

    deleteSelectedTerminationFile = (name) => {
        let newFiles = [];
        this.state.selectedTerminationFile.map((item, i) => {
            if (item.name !== name) {
                newFiles.push(item);
            }
        });
        this.setState({ selectedTerminationFile: newFiles });
        this.setState({ ComponentFileUpload: newFiles });
    };

    GetTaskDescription = (ID) => {
        let taskDescDocuments1 = [];
        let taskDescDocumentsName1 = [];
        let deletedDocuments = [];
        let dataArray = this.state.updatedTaskDocuments;
        var url = "/api/TaskDetail/GetTaskDescriptionByID?ID=" + ID;
        callAPI(callApiGet, url, {}, (res) => {
            if (res.data.Documents.length > 0) {
                for (let i = 0; i < res.data.Documents.length; i++) {
                    let currentDocument = res.data.Documents[i];
                    if (currentDocument.DocumentType === "2") {
                        taskDescDocuments1.push(currentDocument);
                        taskDescDocumentsName1.push(
                            currentDocument.FilePath.toString().split("/")[
                            currentDocument.FilePath.toString().split("/").length - 1
                            ]
                        );
                        this.setState({
                            taskDescDocumentsName: taskDescDocumentsName1,
                            taskDescDocuments: taskDescDocuments1,
                        });
                    }
                }
            }

            this.setState({
                visibleAciklamaGüncelle: true,
                updatedDescription: res.data.Description,
                updateViewClient: res.data.ViewClient,
                selectedTaskLogId: ID,
                tempViewClient: res.data.ViewClient,
                updatedTaskDocuments: res.data.Documents,
            });
        });
    };

    GetRecentlyViewed = (taskID) =>
        new Promise((resolve) => {
            const safeTaskID = taskID == null ? "" : String(taskID).trim();
            if (
                safeTaskID === "" ||
                safeTaskID.toLowerCase() === "undefined" ||
                safeTaskID.toLowerCase() === "null"
            ) {
                this.setState({ recentlyViewed: [], recentlyViewedLoaded: false });
                resolve(false);
                return;
            }
            var url = "/api/TaskDetail/GetRecentlyViewed?TaskID=" + encodeURIComponent(safeTaskID);
            callAPI(callApiGet, url, {}, async (res) => {
                const list = Array.isArray(res?.data) ? res.data : [];
                this.setState({
                    recentlyViewed: list,
                    recentlyViewedLoaded: true,
                    tabCounts: {
                        ...this.state.tabCounts,
                        recentlyViewed: list.length,
                    },
                });
                //this.getData()
                resolve(true);
            });
        });

    AddRecentlyViewed = (taskID) =>
        new Promise((resolve) => {
            const safeTaskID = taskID == null ? "" : String(taskID).trim();
            if (
                safeTaskID === "" ||
                safeTaskID.toLowerCase() === "undefined" ||
                safeTaskID.toLowerCase() === "null"
            ) {
                resolve(false);
                return;
            }
            const url = "/api/TaskDetail/AddRecentlyViewed?TaskID=" + encodeURIComponent(safeTaskID);
            callAPI(callApiGet, url, {}, () => resolve(true), true, () => resolve(false));
        });

    GetTaskDetailTabCounts = (taskID) => {
        const safeTaskID = taskID == null ? "" : String(taskID).trim();
        if (
            safeTaskID === "" ||
            safeTaskID.toLowerCase() === "undefined" ||
            safeTaskID.toLowerCase() === "null"
        ) {
            return;
        }
        const url = "/api/TaskDetail/GetTaskDetailTabCounts?taskID=" + encodeURIComponent(safeTaskID);
        callAPI(callApiGet, url, {}, (res) => {
            const data = res?.data || {};
            this.safeSetState({
                tabCounts: {
                    jobs: Number(data.Jobs || 0),
                    recentlyViewed: Number(data.RecentlyViewed || 0),
                    watchers: Number(data.Watchers || 0),
                    forms: Number(data.Forms || 0),
                    sheets: Number(data.Sheets || 0),
                    extraInfo: Number(data.ExtraInfo || 0),
                },
            });
        }, true);
    };

    changeTaskCanceled = () => {
        this.setState({ changeCategoryModalVisible: false });
        this.props.actions.isLoading(false);
    };

    changeCategoryByTask = () => {
        if (
            this.state.data.WorkStatusID === "a4a9cfb1-f85a-eb11-a2cb-005056b81088"
        ) {
            return notify(this.languages.lutfenTalebiOnceIslemeAlınız, "error", 3000);
        }
        let changeTaskCtegoryDto = {
            TaskID: this.state.taskID,
            CategoryID: this.state.selectedCategoryID,
        };
        let formData = new FormData();
        formData.append("jsonText", JSON.stringify(changeTaskCtegoryDto));
        this.props.actions.isLoading(true);

        const responseText = (d) =>
            typeof d === "string" ? d.trim() : d;

        callAPI(
            callApiPost,
            "/api/TaskDetail/ChangeTaskCategory",
            formData,
            (res) => {
                try {
                    const dataStr = responseText(res.data);
                    if (res.data) {
                        if (dataStr === "Seçmiş Olduğunuz Kategori Onaya Tabidir !!!") {
                            this.props.actions.isLoading(false);
                            BB.askYesNo(res.data, this.languages.onaylıyorMusunuz, this.languages.evet, this.languages.vazgec).then(
                                (ask) => {
                                    if (ask === true) {
                                        this.props.actions.isLoading(true);
                                        callAPI(
                                            callApiPost,
                                            "/api/TaskDetail/ChangeTaskStatusAndManagerID",
                                            formData,
                                            (res) => {
                                                try {
                                                    const innerStr = responseText(res.data);
                                                    this.setState({ changeCategoryModalVisible: false });
                                                    if (innerStr === "Hata") {
                                                        notify(
                                                            this.languages.talepSahibininYöneticisiBosOlamaz,
                                                            "error",
                                                            2000
                                                        );
                                                    } else {
                                                        notify(
                                                            this.languages.kategoriBasarıIleDegistirildi,
                                                            "success",
                                                            4000
                                                        );
                                                    }
                                                    this.getData();
                                                } catch (e) {
                                                    console.error(e);
                                                    this.props.actions.isLoading(false);
                                                    notify(this.languages.kategoriDegistirilemedi, "error", 2000);
                                                }
                                            },
                                            false,
                                            () => {
                                                this.props.actions.isLoading(false);
                                                notify(this.languages.kategoriDegistirilemedi, "error", 2000);
                                            }
                                        );
                                    }
                                }
                            ).catch(() => {
                                this.props.actions.isLoading(false);
                            });
                        } else if (
                            dataStr === "Sonlandırılmış Bir Talebin Kategorisi Değiştirilemez."
                        ) {
                            notify(
                                this.languages.sonlandırılmısBirTalebinKategorisiDegistirilemez,
                                "error",
                                2000
                            );

                            this.setState({ changeCategoryModalVisible: false });
                            this.props.actions.isLoading(false);
                        } else if (
                            dataStr ===
                            "Seçmiş Olduğunuz Kategori Talebin Kategorisi İle Aynıdır ."
                        ) {
                            notify(
                                this.languages.secmisOldugunuzKategoriTalebinKategorisiIleAynıdır,
                                "error",
                                2000
                            );

                            this.setState({ changeCategoryModalVisible: false });
                            this.props.actions.isLoading(false);
                        } else if (
                            dataStr ===
                            "Seçmiş Olduğunuz Kategorinin Onay Seviyesi Mevcut Kategoriden Farklıdır Lütfen İptal Edip Tekrar Talep Açınız !!!"
                        ) {
                            notify(
                                this.languages.secmisOldugunuzKategorininOnaySeviyesiMevcutKategoridenFarklıdırLutfenIptalEdipTekrarTalepAcınız,
                                "error",
                                4000
                            );

                            this.setState({ changeCategoryModalVisible: false });
                            this.props.actions.isLoading(false);
                        } else if (dataStr === "Başarılı") {
                            this.setState({ changeCategoryModalVisible: false });

                            notify(this.languages.kategoriBasarıIleDegistirildi, "success", 2000);
                            this.getData();
                            this.props.actions.isLoading(false);
                        } else {
                            const errText =
                                typeof dataStr === "string" && dataStr.length > 0
                                    ? dataStr
                                    : this.languages.kategoriDegistirilemedi;
                            notify(errText, "error", 5000);
                            this.props.actions.isLoading(false);
                        }
                    } else {
                        notify(this.languages.kategoriDegistirilemedi, "error", 2000);
                        this.props.actions.isLoading(false);
                    }
                } catch (e) {
                    console.error(e);
                    notify(this.languages.kategoriDegistirilemedi, "error", 3000);
                    this.props.actions.isLoading(false);
                }
            },
            false,
            () => {
                this.props.actions.isLoading(false);
            }
        );
    };

    GetWatcherUsers = (taskID) =>
        new Promise((resolve) => {
            if (!taskID) {
                this.setState({ WatcherUsers: [], watcherUsersLoaded: false });
                resolve(false);
                return;
            }
            var url = "/api/TaskDetail/GetWatcherUsers?TaskID=" + taskID;
            callAPI(callApiGet, url, {}, async (res) => {
                const list = Array.isArray(res?.data) ? res.data : [];
                this.setState({
                    WatcherUsers: list,
                    watcherUsersLoaded: true,
                    tabCounts: {
                        ...this.state.tabCounts,
                        watchers: list.length,
                    },
                });
                resolve(true);
            });

            // BB.FetchJSON('/api/TaskDetail/GetWatcherUsers?TaskID=' + taskID).then(GetWatcherUsers => {
            //     this.setState({
            //         WatcherUsers: GetWatcherUsers
            //     })
            //     resolve(true);
            // });
        });

    deleteJob(ID) {
        this.props.actions.isLoading(true);

        callAPI(
            callApiGet,
            "/api/TaskTracking/DeleteJob?jobID=" + ID,
            {},
            (res) => {
                if (res?.data) {
                    this.props.actions.isLoading(false);

                    this.setState({
                        selectedUserId: undefined,
                        //taskID: undefined,
                        selectedMessage: "",
                    });
                    var url =
                        "api/TaskTracking/GetJobsByTaskID?TaskID=" + this.state.taskID;
                    callAPI(callApiGet, url, {}, (GetMyJobs) => {
                        if (GetMyJobs.data) {
                            this.setState({
                                myJobs: GetMyJobs.data,
                            });
                        }
                    });
                    notify(this.languages.Görevbaşarıylasilindi, "success", 2000);
                } else {
                    this.props.actions.isLoading(false);
                    notify(this.languages.gorevIptalEdilirkenHata, "error", 2000);
                }
            },
            true
        );
    }

    changeResponsibleUserByTask() {
        let responsibleUserChange = {
            TaskID: this.state.taskID,
            NewResponsibleUserID: this.state.selectedOverUserId,
        };
        if (this.state.selectedOverUserId === this.state.data.ResponsibleUserID) {
            notify(this.languages.talepAynıKisiyeDevirEdilemez, "error", 2000);
            return;
        }

        let formData = new FormData();
        formData.append("jsontext", JSON.stringify(responsibleUserChange));

        callAPI(
            callApiPost,
            "api/TaskDetail/ChangeResponsibleUserByTask",
            formData,
            (res) => {
                if (
                    res.data === "Sonlandırılmış Bir Talebin Sorumlusu Değiştirilemez."
                ) {
                    this.setState({
                        takeOverUserVisible: false,
                        selectedOverUserId: undefined,
                    });
                    // this.setState({ visibleJob: false });
                    this.getData();
                    notify(
                        this.languages.sonlandırılmısBirTalebinSorumlusuDegistirilemez,
                        "error",
                        2000
                    );
                } else if (res.data) {
                    this.setState({
                        takeOverUserVisible: false,
                        selectedOverUserId: undefined,
                    });
                    // this.setState({ visibleJob: false });
                    this.getData();
                    notify(this.languages.talebbasarıiledevredildi, "success", 2000);

                    // var url =
                    //   "api/TaskTracking/GetJobsByTaskID?TaskID=" + this.state.taskID;
                    // callAPI(callApiGet, url, {}, (GetMyJobs) => {
                    //   this.setState({
                    //     myJobs: GetMyJobs.data,
                    //   });
                    // });
                    // this.setState({
                    //   selectedUserId: undefined,
                    //   selectedMessage: "",
                    //   visibleJob: false,
                    // });
                } else {
                    notify(this.languages.talepDevredilirkenHata, "error", 2000);
                }
            }
        );
    }

    addAssignAJob() {
        let jobDto = {
            TaskID: this.state.taskID,
            ResponsibleUserID: this.state.selectedUserId,
            Description: this.state.selectedMessage,
        };
        let formData = new FormData();
        formData.append("jsonText", JSON.stringify(jobDto));
        this.props.actions.isLoading(true);

        callAPI(callApiPost, "api/TaskTracking/AddAssignAJob", formData, (res) => {
            if (res.data) {
                this.setState({ visibleJob: false });

                notify(this.languages.Görevbaşarıylaatandı, "success", 2000);
                this.props.actions.isLoading(false);

                var url =
                    "api/TaskTracking/GetJobsByTaskID?TaskID=" + this.state.taskID;
                callAPI(callApiGet, url, {}, (GetMyJobs) => {
                    this.setState({
                        myJobs: GetMyJobs.data,
                    });
                });
                this.setState({
                    selectedUserId: undefined,
                    selectedMessage: "",
                    visibleJob: false,
                });
            } else {
                notify(this.languages.görevatanamadi, "error", 2000);
            }
        });
    }

    taskActions(actionType) {
        let ths = this;
        let taskID = this.state.data.ID;
        let categoryID = this.state.data.CategoryID;

        if (actionType === "aciklamaekle") {
            this.GetCompanyUsers(this.state.taskID);
            this.setState({ visibleAciklamaEkle: true });
        }
        if (actionType === "devret") {
            this.setState({ visibleDevret: true });
        }
        if (actionType === "onayla") {
            Swal.fire({
                title: this.languages.onayAciklamasiGiriniz,
                input: "textarea",
                inputAttributes: {
                    "aria-label": "Type your message here",
                },
                showCancelButton: true,
                confirmButtonText: this.languages.onayVer,
                cancelButtonText: this.languages.iptal,
                showLoaderOnConfirm: true,
                preConfirm: (login) => {
                    ths.props.actions.isLoading(true);

                    let url =
                        "/api/OwnConfirmTask/Confirm?id=" +
                        taskID +
                        "&Description=" +
                        login;

                    return BB.FetchTEXT(url).then((res) => {
                        return res;
                    });
                },
                allowOutsideClick: () => !Swal.isLoading(),
            }).then((result) => {
                if (result.isConfirmed === true && result.value === "false") {
                    timeoutPopup(
                        this.languages.talepDahaOnceOnaylanmıştır,
                        "warning",
                        this.languages.tamam,
                        4000
                    );
                } else if (result.isConfirmed) {
                    ths.getData();

                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: this.languages.onayBasariylaVerilmistir,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    ths.props.actions.isLoading(false);
                }
            });
        }
        if (actionType === "reddet") {
            Swal.fire({
                title: this.languages.redAcıklamasıGiriniz,
                input: "textarea",
                inputAttributes: {
                    "aria-label": "Type your message here",
                },
                showCancelButton: true,
                confirmButtonText: this.languages.redded,
                cancelButtonText: this.languages.vazgec,
                showLoaderOnConfirm: true,
                preConfirm: (login) => {
                    let url =
                        "/api/OwnConfirmTask/Reject?id=" + taskID + "&Description=" + login;

                    return BB.FetchTEXT(url).then((res) => {
                        ths.props.actions.isLoading(false);
                        return res;
                    });
                },
                allowOutsideClick: () => !Swal.isLoading(),
            }).then((result) => {
                if (result.isConfirmed === true && result.value === "false") {
                    timeoutPopup(
                        this.languages.talepdahaöncereddedilmiştir,
                        "warning",
                        this.languages.tamam,
                        4000
                    );
                } else if (result.isConfirmed) {
                    ths.getData();

                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: this.languages.talepBasariylaIptalEdilmistir,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    ths.props.actions.isLoading(true);
                }
            });
        }
        if (actionType === "ownerReddet") {
            callAPI(
                callApiGet,
                "api/DataCheck/OverCheck?TaskID=" + taskID,
                {},
                (res) => {
                    if (res.data === true) {
                        Swal.fire({
                            title: this.languages.iptalAciklamasiGiriniz,
                            input: "textarea",
                            inputAttributes: {
                                "aria-label": "Type your message here",
                            },
                            showCancelButton: true,
                            confirmButtonText: this.languages.tamam,
                            cancelButtonText: this.languages.vazgec,
                            showLoaderOnConfirm: true,
                            preConfirm: (login) => {
                                callAPI(
                                    callApiGet,
                                    "/api/TaskDetail/RejectTaskByOwner?TaskID=" +
                                    taskID +
                                    "&StatusID=AA2DF37B-8AC8-E811-80F6-005056B839BB&Description=" +
                                    login,
                                    {},
                                    (data) => {
                                        ths.props.actions.isLoading(false);
                                        return data.data;
                                    }
                                );
                            },
                            allowOutsideClick: () => !Swal.isLoading(),
                        }).then((result) => {
                            if (result.isConfirmed) {
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: this.languages.talepBasariylaIptalEdilmistir,
                                    showConfirmButton: false,
                                    timer: 1500,
                                }).then(() => {
                                    window.location.reload();
                                });
                            }
                        });
                    } else {
                        timeoutPopup(
                            this.languages.talepdevralınmış,
                            "warning",
                            this.languages.tamam,
                            6000
                        );
                    }
                }
            );
        }
        if (actionType === "devral") {
            Swal.fire({
                title: this.languages.eminMisiniz,
                text: this.languages.talebiDevralacaksiniz,
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: this.languages.iptal,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.languages.devral,
            }).then((result) => {
                if (result.isConfirmed === true) {
                    var urlCheck = "api/DataCheck/OverCheck2?TaskID=" + taskID;
                    callAPI(callApiGet, urlCheck, {}, async (res) => {
                        if (res?.data === true) {
                            var url = "/api/TaskDetail/Over?id=" + taskID;
                            ths.props.actions.isLoading(true);
                            callAPI(callApiGet, url, {}, async (result) => {
                                if (result?.data?.Status === 1) {
                                    notify(result.data.Message, "success", 2000);
                                } else {
                                    notify(
                                        result?.data?.Message || this.languages.talebdahaöncesindeişlemealımıs,
                                        "warning",
                                        3000
                                    );
                                }
                                // Son durum tek sefer güncellensin.
                                ths.getData();
                                ths.props.actions.isLoading(false);
                            }, false, () => ths.props.actions.isLoading(false));
                        } else {
                            timeoutPopup(
                                this.languages.talebdahaöncesindeişlemealımıs,
                                "warning",
                                this.languages.tamam,
                                6000
                            );
                        }
                    });
                }
            });
        }
        if (actionType === "aciliyetdegistir") {
            this.setState({ visibleAciliyet: true });
        }

        if (actionType === "sonlandir") {
            var url = "/api/TaskDetail/GetCustomElementsForClosing?id=" + categoryID;
            callAPI(callApiGet, url, {}, async (customElements) => {
                if (customElements.data) {
                    //let customControls = JSON.parse(customElements.data);
                    let sortedCustomControls = customElements.data.sort(function (a, b) {
                        return a.OrderNumber - b.OrderNumber;
                    });
                    this.setState({ customElements: sortedCustomControls });
                } else {
                    this.setState({ customElements: null });
                }
            });

            const terminationStatusData = new CustomStore({
                loadMode: "raw",
                key: "ID",
                load: function () {
                    return BB.FetchJSON("/api/TaskDetail/GetTerminationStatuses").then(
                        (data) => {
                            return data;
                        }
                    );
                },
            });

            this.setState({ terminationStatus: terminationStatusData });

            const terminateTemplateData = new CustomStore({
                loadMode: "raw",
                key: "ID",
                load: function () {
                    return BB.FetchJSON("/api/TaskDetail/GetTerminateTemplates").then(
                        (data) => {
                            return data;
                        }
                    );
                },
            });

            this.setState({ terminateTemplate: terminateTemplateData });

            const inProgressStatusId = "b22df37b-8ac8-e811-80f6-005056b839bb";
            const currentWorkStatusId = (this.state.data.WorkStatusID || "").toLowerCase();
            if (currentWorkStatusId === inProgressStatusId) {
                this.setState({ visibleSonlandir: true });
            } else {
                notify(
                    this.languages.TalepişlemdurumutalebikapatmayauygundeğilÖncelikleİşlemeAlınız,
                    "error",
                    5000
                );
            }
        }

        if (actionType === "durumDegistir") {
            const inProgressStatusId = "b22df37b-8ac8-e811-80f6-005056b839bb";
            //İşlem Durumu : işleme alındı
            if (
                this.state.data.WorkStatusID !==
                inProgressStatusId &&
                this.state.data.WorkStatusID !== null
            ) {
                this.props.actions.isLoading(true);

                // callAPI(
                //     callApiGet,
                //     url,
                //     {},
                //     async (data) => {
                //         return data.data;

                // })

                let url =
                    "api/TaskDetail/UpdateStatus?TaskID=" +
                    taskID +
                    "&StatusID=" +
                    inProgressStatusId;
                callAPI(callApiGet, url, {}, async (data) => {
                    if (data.data.Status) {
                        notify(
                            this.languages.talepDurumDegistirmeBasarili,
                            "success",
                            2000
                        );
                        this.setState((prevState) => {
                            const currentStatuses = prevState.status || [];
                            const inProgressStatus = currentStatuses.find(
                                (x) => x?.ID === inProgressStatusId
                            );
                            const inProgressStatusName =
                                inProgressStatus?.Name ||
                                inProgressStatus?.name ||
                                "İşleme Alındı";
                            return {
                                data: {
                                    ...prevState.data,
                                    WorkStatusID: inProgressStatusId,
                                    WorkStatus: {
                                        ...(prevState.data?.WorkStatus || {}),
                                        ...(inProgressStatus || {}),
                                        Name: inProgressStatusName,
                                    },
                                },
                            };
                        });
                    } else {
                        notify(data.data.Message, "error", 2000);
                    }
                    this.props.actions.isLoading(false);
                }, true, async () => {
                    this.props.actions.isLoading(false);
                });

                // BB.FetchJSON(url).then(data => {
                //     notify(this.languages.talepDurumDegistirmeBasarili, "success", 2000);
                //     this.getData();
                //     this.GetProccessStatus();
                // });
            } else {
                this.GetProccessStatus();
                this.setState({ visibleDurumDegistir: true });
            }
        }
        if (actionType === "formGoruntule") {
            const taskID = this.state.taskID || this.state.data?.ID;
            if (!taskID) {
                notify("Talep bilgisi henuz yuklenmedi.", "warning", 2000);
                return;
            }
            if (this.state.customFormLoaded) {
                this.setState({ previewVisible: true });
            } else {
                this.props.actions.isLoading(true);
                this.GetCustomForm(taskID)
                    .then((forms) => {
                        if ((forms || []).length > 0) {
                            this.setState({ previewVisible: true });
                        } else {
                            notify("Talebe ait form bulunamadı.", "warning", 2500);
                        }
                    })
                    .finally(() => this.props.actions.isLoading(false));
            }
        }
        if (actionType === "sheetGoruntule") {
            const taskID = this.state.taskID || this.state.data?.ID;
            if (!taskID) {
                notify("Talep bilgisi henuz yuklenmedi.", "warning", 2000);
                return;
            }
            if (this.state.customSheetLoaded) {
                this.setState({ preview2Visible: true });
            } else {
                this.props.actions.isLoading(true);
                this.GetCustomSheet(taskID)
                    .then((sheets) => {
                        if ((sheets || []).length > 0) {
                            this.setState({ preview2Visible: true });
                        } else {
                            notify("Talebe ait tablo bulunamadı.", "warning", 2500);
                        }
                    })
                    .finally(() => this.props.actions.isLoading(false));
            }
        }
    }

    renderActionButtons() {
        const { t } = this.props;

        let Model = this.state.data;
        let usr = this.state.loginUser;
        if (!usr || !Model || Array.isArray(Model)) return null;

        const normGuid = (g) => (g == null || g === "" ? "" : String(g).toLowerCase());
        const responsibleUserID =
            Model.responsibleUserID ?? Model.ResponsibleUserID;
        const statusID = Model.statusID ?? Model.StatusID;
        const createUserID = Model.createUserID ?? Model.CreateUserID;
        const taskLog = Model.taskLog ?? Model.TaskLog ?? [];
        const taskConfirmation =
            Model.taskConfirmation ?? Model.TaskConfirmation ?? [];

        const emptyGuid = "00000000-0000-0000-0000-000000000000";
        const loginUserGuid = normGuid(usr.id ?? usr.ID);
        const rawIsLastUser = usr.isLastUser ?? usr.IsLastUser;
        const isLastUserProfile =
            rawIsLastUser === true ||
            rawIsLastUser === "True" ||
            String(rawIsLastUser).toLowerCase() === "true";
        const isNoResponsible =
            responsibleUserID == null ||
            responsibleUserID === "" ||
            normGuid(responsibleUserID) === emptyGuid;
        const statusIdNorm = normGuid(statusID);
        const sameUserAsResponsible =
            !isNoResponsible && normGuid(responsibleUserID) === loginUserGuid;

        let isConfirmed = true;
        let isCancel =
            isNoResponsible
                ? taskLog.length === 2
                    ? normGuid(createUserID) === loginUserGuid
                        ? true
                        : false
                    : false
                : false;

        if (!this.usr) {
            //Talep çözümlenmediyse
            const terminationDate =
                Model.terminationDate ?? Model.TerminationDate;
            if (!terminationDate) {
                if (taskConfirmation && taskConfirmation.length > 0) {
                    for (let i = 0; i < taskConfirmation.length; i++) {
                        const row = taskConfirmation[i];
                        const appr = row.approvalDate ?? row.ApprovalDate;
                        if (appr === null || appr === undefined) {
                            isConfirmed = false;
                        }
                    }
                }

                //Talep çözümlenmediyse ve Onay verecek birisi var ise
                if (
                    taskConfirmation &&
                    taskConfirmation.length > 0 &&
                    !isConfirmed
                ) {
                    let showConfirmButtons = false;
                    let previousConfirmed = false;

                    const row0 = taskConfirmation[0];
                    const u0 = row0.userID ?? row0.UserID;
                    const p0 = row0.procurationUserID ?? row0.ProcurationUserID;
                    const a0 = row0.approvalDate ?? row0.ApprovalDate;

                    //Eğer login olan kullanıcı sıradaki onay verecek kişi ise
                    if (
                        ((a0 === null || a0 === undefined) &&
                            normGuid(u0) === loginUserGuid) ||
                        normGuid(p0) === loginUserGuid
                    ) {
                        showConfirmButtons = true;
                    } else {
                        for (let i = 0; i < taskConfirmation.length; i++) {
                            const row = taskConfirmation[i];
                            const uid = row.userID ?? row.UserID;
                            const pid = row.procurationUserID ?? row.ProcurationUserID;
                            const appr = row.approvalDate ?? row.ApprovalDate;
                            if (
                                normGuid(uid) === loginUserGuid ||
                                (normGuid(pid) === loginUserGuid &&
                                    previousConfirmed === true)
                            ) {
                                if (appr === null || appr === undefined) {
                                    showConfirmButtons = true;
                                } else {
                                    showConfirmButtons = false;
                                }
                            }
                            if (appr !== null && appr !== undefined) {
                                previousConfirmed = true;
                            } else {
                                previousConfirmed = false;
                            }
                        }
                    }

                    // for (let i = 0; i < Model.TaskConfirmation.length; i++) {
                    //   if (
                    //     Model.TaskConfirmation[i].ApprovalDate === null &&
                    //     Model.ConfirmingManagerID !== this.state.loginUser.ID
                    //   ) {
                    //     showConfirmButtons = false;
                    //   }

                    // }

                    return (
                        <Row className="align-items-center">
                            {showConfirmButtons && (
                                <Col>
                                    <Button
                                        block
                                        outline
                                        color="primary"
                                        onClick={() => this.taskActions("onayla")}
                                    >
                                        {t("onayla")}
                                    </Button>
                                </Col>
                            )}
                            {showConfirmButtons && (
                                <Col>
                                    <Button
                                        block
                                        outline
                                        color="primary"
                                        onClick={() => this.taskActions("reddet")}
                                    >
                                        {t("reddet")}
                                    </Button>
                                </Col>
                            )}
                            {isCancel === true && (
                                <Col>
                                    <Button
                                        block
                                        color="danger"
                                        onClick={() => this.taskActions("ownerReddet")}
                                    >
                                        {t("iptal")}
                                    </Button>
                                </Col>
                            )}
                        </Row>
                    );
                } else {
                    if (!isLastUserProfile) {
                        //Talep devranılmadıysa ve Yönetici reddetmediyse
                        if (
                            isNoResponsible &&
                            statusIdNorm !== normGuid("A62DF37B-8AC8-E811-80F6-005056B839BB") &&
                            !terminationDate
                        ) {
                            if (isCancel === true) {
                                return (
                                    <Row>
                                        <Col style={{ height: 37, marginTop: 5 }}>
                                            <Button
                                                block
                                                color="danger"
                                                onClick={() => this.taskActions("ownerReddet")}
                                            >
                                                {t("iptal")}
                                            </Button>
                                        </Col>
                                        <Col style={{ height: 37, marginTop: 5 }}>
                                            <Button
                                                block
                                                color="warning"
                                                onClick={() => this.taskActions("devral")}
                                            >
                                                {t("devral")}
                                            </Button>
                                        </Col>
                                    </Row>
                                );
                            } else {
                                //Talep sahibi tarafından iptal edilmemişse
                                if (statusIdNorm !== "aa2df37b-8ac8-e811-80f6-005056b839bb") {
                                    return (
                                        <Col style={{ height: 37, marginTop: 5 }}>
                                            <Button
                                                block
                                                color="warning"
                                                onClick={() => this.taskActions("devral")}
                                            >
                                                {t("devral")}
                                            </Button>
                                        </Col>
                                    );
                                }
                            }
                        }

                        //Talep Yönetici onayında beklemiyorsa
                        if (
                            !isNoResponsible &&
                            statusIdNorm !== "a42df37b-8ac8-e811-80f6-005056b839bb"
                        ) {
                            if (sameUserAsResponsible) {
                                return (
                                    <Row style={{ marginTop: 8 }}>
                                        <Col>
                                            <Button
                                                block
                                                outline
                                                color="primary"
                                                onClick={() => this.taskActions("devret")}
                                            >
                                                {t("devret")}
                                            </Button>
                                        </Col>
                                        <Col>
                                            <Button
                                                outline
                                                block
                                                color="primary"
                                                onClick={() => this.taskActions("aciliyetdegistir")}
                                            >
                                                {t("aciliyetdeğiştir")}
                                            </Button>
                                        </Col>
                                    </Row>
                                );
                            }
                        }
                    } else {
                        const showResponsibleDevretAciliyet =
                            sameUserAsResponsible &&
                            statusIdNorm !== "a42df37b-8ac8-e811-80f6-005056b839bb";
                        if (showResponsibleDevretAciliyet) {
                            return (
                                <Row style={{ marginTop: 8 }}>
                                    <Col>
                                        <Button
                                            block
                                            outline
                                            color="primary"
                                            onClick={() => this.taskActions("devret")}
                                        >
                                            {t("devret")}
                                        </Button>
                                    </Col>
                                    <Col>
                                        <Button
                                            outline
                                            block
                                            color="primary"
                                            onClick={() => this.taskActions("aciliyetdegistir")}
                                        >
                                            {t("aciliyetdeğiştir")}
                                        </Button>
                                    </Col>
                                    {isCancel === true && (
                                        <Col>
                                            <Button
                                                block
                                                color="danger"
                                                onClick={() => this.taskActions("ownerReddet")}
                                            >
                                                {t("iptal")}
                                            </Button>
                                        </Col>
                                    )}
                                </Row>
                            );
                        }
                        return (
                            <Row>
                                {isCancel === true && (
                                    <Col>
                                        <Button
                                            block
                                            color="danger"
                                            onClick={() => this.taskActions("ownerReddet")}
                                        >
                                            {t("iptal")}
                                        </Button>
                                    </Col>
                                )}
                            </Row>
                        );
                    }
                }
            }
        } else {
            return (
                <Row>
                    {isCancel === true && (
                        <Col>
                            <Button
                                block
                                color="danger"
                                onClick={() => this.taskActions("ownerReddet")}
                            >
                                {t("iptal")}
                            </Button>
                        </Col>
                    )}
                </Row>
            );
        }
    }

    handleChange(key, value, description) {
        let currentSelectedCustomControl = Array.isArray(this.state.selectedCustomControl)
            ? [...this.state.selectedCustomControl]
            : [];
        const customElements = Array.isArray(this.state.customElements)
            ? this.state.customElements
            : [];
        let isCustomControl = customElements.filter((x) => x.ID == key);

        if (isCustomControl.length > 0) {
            let hasAlready = currentSelectedCustomControl.filter((x) => x.ID == key);

            if (hasAlready.length > 0) {
                let currentIndex = currentSelectedCustomControl.indexOf(hasAlready);
                currentSelectedCustomControl.splice(currentIndex, 1);

                if (isCustomControl[0].CustomControlType === 2) {
                    let item = { ID: key, Value: value };
                    currentSelectedCustomControl.push(item);
                } else {
                    let item = { ID: key, Value: value };
                    currentSelectedCustomControl.push(item);
                }
            } else {
                if (isCustomControl[0].CustomControlType === 2) {
                    let item = { ID: key, Value: value };
                    currentSelectedCustomControl.push(item);
                } else {
                    let item = { ID: key, Value: value };
                    currentSelectedCustomControl.push(item);
                }
            }
            this.setState({ selectedCustomControl: currentSelectedCustomControl });
        }
        if (key === "additionalDescription") {
            this.setState({ additionalDescriptionValue: value });
        }
        if (key === "selectedCategoryID") {
            this.setState({ selectedCategoryID: value });
        }
        if (key === "selectedDegreeOfUrency") {
            this.setState({ selectedDegreeOfUrency: value });
        }
        if (key === "selectedTaskFiles") {
            this.setState({ selectedTaskFiles: value });
        }
        if (key === "selectedProjectNumber") {

            var s = this.state.data

            this.setState({ selectedProjectNumber: value });
        }
        if (key === "effor") {

            this.setState({ effor: value });
        }
        if (key === "descriptionUpdate") {
            this.setState({ visibleAciklamaGüncelle: value });
        }
        if (key === "selectedUserId") {
            this.setState({ selectedUserId: value });
        }
        if (key === "selectedMessage") {
            this.setState({ selectedMessage: value });
        }
        if (key === "selectedOverUserId") {
            this.setState({ selectedOverUserId: value });
        }
        if (key === "selectedDegreeOfUrencyDesc") {
            this.setState({ selectedDegreeOfUrencyDesc: value });
        }
        if (key === "selectedTerminationDescription") {
            this.setState({ selectedTerminationDescription: value });
        }
        if (key === "selectedTerminationType") {
            this.setState({ selectedTerminationType: value });
        }
        if (key === "selectedTerminationTemplate") {
            this.setState({
                selectedTerminationTemplate: value,
                selectedTerminationDescription: description,
            });
        }
        if (key === "selectedTerminationFile") {
            this.setState({ selectedTerminationFile: value });
        }
        if (key === "selectedPoolDevret") {
            this.setState({ selectedPoolDevret: value, selectedPoolUserID: null });
        }
        if (key === "selectedUserDevret") {
            this.setState({ selectedUserDevret: value });
        }
        if (key === "selectedDescriptionDevret") {
            this.setState({ selectedDescriptionDevret: value });
        }
        if (key === "selectedAdditionalConfirmationDescription") {
            this.setState({ selectedAdditionalConfirmationDescription: value });
        }
        if (key === "selectedCompanyUserID") {
            this.setState({ selectedCompanyUserID: value });
        }
        if (key === "selectedCommentDescription") {
            this.setState({ selectedCommentDescription: value });
        }
        if (key === "selectedCommentFiles") {
            this.setState({ selectedCommentFiles: value });
        }
        if (key === "customElementItemsDatas") {
            this.setState({ customElementItemsDatas: value });
        }
        if (key === "selectedStatus") {
            this.setState({ selectedStatus: value });
        }
        if (key === "selectedPoolUserID") {
            this.setState({ selectedPoolUserID: value });
        }
        if (key === "selectedTaskFilesState") {
            this.setState({ fileUploaderVisible: value });
        }
        if (key === "selectedEndDate") {
            if (value < new Date()) {
                notify(this.languages.Dahaöncekibirzamanseçemezsiniz, "warning", 2000);
            } else {
                this.setState({ selectedEndDate: value });
            }
        }
        if (key === "selectedLastStatus") {
            this.setState({ selectedLastStatus: value });
        }
        if (key === "selectedShareOtherMails") {
            this.setState({ selectedShareOtherMails: value });
        }
        if (key === "selectedWatcherUsers") {
            this.setState({ selectedWatcherUsers: value });
        }
        if (key === "selectedCategory") {
            this.setState({ selectedCategory: value });
        }
        if (key === "selectedWatcherUserID") {
            this.setState({ selectedWatcherUserID: value });
        } else {
            this.setState({ [key]: value });
        }
        if (key === "selectedShareOwner") {
            this.setState({ selectedShareOwner: !this.state.selectedShareOwner });
        }
        if (key === "selectedIsUatApproved") {
            this.setState({ selectedIsUatApproved: !this.state.selectedIsUatApproved });
        }
        if (key === "NotifyDepartment") {
            this.setState({ NotifyDepartment: !this.state.NotifyDepartment });
        }
        if (key === "selectedShareOther") {
            this.setState({ selectedShareOther: !this.state.selectedShareOther });
        }
        if (key === "selectedCompanyID") {
            callAPI(
                callApiGet,
                `/api/Task/GetCompanyUsersForAdditionalConfirmation?id=` + value,
                {},
                (res) => {
                    if (res?.data) {
                        this.setState({ companyUser: res?.data });

                        this.props.actions.isLoading(false);
                    }
                },
                true
            );
        }
    }

    checkIsLastUser = () => {
        let url = "api/TaskDetail/IsLastUser";
        callAPI(callApiGet, url, {}, (res) => {
            if (res.data) {
                this.setState({ isLastUser: "none" });
            } else {
                this.setState({ isLastUser: "block" });
            }
        });
    };

    getCompanies = () => {
        callAPI(
            callApiGet,
            `/api/Task/GetCompanies`,
            {},
            async (res) => {
                if (res?.data) {
                    this.setState({ companies: res?.data });
                    this.props.actions.isLoading(false);
                }
            },
            true
        );
    };
    getCompanyUser = () => {
        callAPI(
            callApiGet,
            `/api/Task/GetCompanyUsersForAdditionalConfirmation?id=` +
            this.state.selectedCompanyID,
            {},
            (res) => {
                if (res?.data) {
                    this.setState({ companyUser: res?.data });

                    this.props.actions.isLoading(false);
                }
            },
            true
        );
    };
    add = () => {
        store.addNotification({
            title: "Talep Takibi başarılı!",
            message:
                "18 Numaralı talep hakkında bütün işlemler size bildirim & mail olarak gönderilecektir",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true,
            },
        });
    };
    onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
        this.setState((state) => {
            const rows = state.rows.slice();
            for (let i = fromRow; i <= toRow; i++) {
                rows[i] = { ...rows[i], ...updated };
            }
            return { rows };
        });
    };
    getCustomSheet() {
        BB.FetchJSON(
            "/api/TaskDetail/GetCustomSheet?TaskID=" + this.state.taskID
        ).then((GetCustomSheet) => {
            this.setState({
                selectedSheetID: GetCustomSheet ? GetCustomSheet[0].FormID : undefined,
                customSheetData: GetCustomSheet ? GetCustomSheet : undefined,
                selectedSheetName: GetCustomSheet ? GetCustomSheet[0].Name : undefined,
                rows: GetCustomSheet ? JSON.parse(GetCustomSheet[0].Values) : [],
                selectedSheet: GetCustomSheet
                    ? JSON.parse(GetCustomSheet[0].Form)
                    : undefined,
            });
        });
    }
    changeEffort = () => {

        if (this.state.data.ResponsibleUser === null) {
            this.getData();
            return notify(
                this.languages.eforKaydınıSadeceTalepSorumlusuGüncelleyebilir,
                "warning",
                2000
            );
        }

        if (this.state.data.ResponsibleUserID !== this.state.loginUser.ID) {

            this.getData();


            return notify(
                this.languages.eforKaydınıSadeceTalepSorumlusuGüncelleyebilir,
                "warning",
                2000
            );

        }
        else {
            if (this.state.effor.length === 0) {

                this.setState({ effor: 0 });
                var url = "/api/TaskDetail/ChangeEffor?TaskID=" + this.state.taskID + "&effor=" + "0"

                callAPI(
                    callApiGet,
                    url,
                    {},
                    (res) => {
                        if (res?.data) {
                            if (res?.data === true) {
                                notify(
                                    this.languages.basarili,
                                    "success",
                                    2000
                                );
                            }
                            else {
                                notify(
                                    this.languages.birHataAlındı,
                                    "warning",
                                    2000
                                );
                            }
                        }
                    },
                    true
                );


            }
            else if (this.state.effor.length > 0) {
                this.setState({ effor: this.state.effor });


                var url = "/api/TaskDetail/ChangeEffor?TaskID=" + this.state.taskID + "&effor=" + this.state.effor

                callAPI(
                    callApiGet,
                    url,
                    {},
                    (res) => {
                        if (res?.data) {
                            if (res?.data === true) {
                                notify(
                                    this.languages.basarili,
                                    "success",
                                    2000
                                );
                            }
                            else {
                                notify(
                                    this.languages.birHataAlındı,
                                    "warning",
                                    2000
                                );
                            }
                        }
                    },
                    true
                );
            }
            else {

            }
        }







    }
    changeProjectNumber = () => {
        //
        let isResponsibleUser =
            this.state.loginUser.ID === this.state.data.ResponsibleUserID;
        let { taskID, selectedProjectNumber } = this.state;

        if (selectedProjectNumber === "DT" || selectedProjectNumber === "dt") {
            this.setState({ visibleAdditionalDescription: true })
        }
        else {
            let URL =
                "api/TaskDetail/ChangeTaskProjectNumber?TaskID=" +
                taskID +
                "&ProjectNumber=" +
                selectedProjectNumber;
            if (isResponsibleUser === true) {
                BB.FetchJSON(URL).then((res) => {
                    if (res === "DT için uygun kategoriler seçili değildir.") {
                        notify(this.languages.DTiçinUygunKategorilerSeciliDegildir, "warning", 2000);
                    } else if (
                        res ===
                        "Bu Talep İçin Önceden Oluşturulmuş Bir Azure Kaydı Mevcuttur. "
                    ) {
                        notify(
                            this.languages.buTalepicinÖncedenOluşturulmuşBirAzureKaydıMevcuttur,
                            "warning",
                            2000
                        );
                    } else if (res === true) {
                        notify(this.languages.basarili, "success", 2000);
                        const isDT = selectedProjectNumber?.toLowerCase() === "dt";
                        this.setState({
                            selectedProjectNumber: isDT
                                ? this.state.vstsid
                                : selectedProjectNumber,
                            data: {
                                ...this.state.data,
                                ProjectNumber: selectedProjectNumber,
                            },
                        });
                    } else {
                        notify(this.languages.birHataAlındı, "warning", 2000);
                    }
                });
            } else {
                notify(
                    this.languages.projeNumarasıAlanınıSadeceTalepSorumlusuDegistirebilir,
                    "warning",
                    3000
                );
            }
        }




    };

    updateUatApproval = () => {
        const { taskID, selectedIsUatApproved } = this.state;
        if (!taskID) return;

        const payload = {
            TaskID: taskID,
            IsUatApproved: selectedIsUatApproved,
            Description: "",
        };

        const formData = new FormData();
        formData.append("jsonText", JSON.stringify(payload));

        this.setState({ uatApprovalSaving: true });
        this.props.actions.isLoading(true);

        callAPI(
            callApiPost,
            "api/TaskDetail/UpdateTaskUatApproval",
            formData,
            (res) => {
                this.props.actions.isLoading(false);
                this.setState({ uatApprovalSaving: false });

                const result = res?.data;
                if (!result) {
                    notify(this.languages.birHataAlındı || "Bir hata alındı", "warning", 2500);
                    return;
                }

                if (result.IsSuccess === true) {
                    notify(result.Message || this.languages.basarili, "success", 2500);
                    this.setState((prevState) => ({
                        selectedIsUatApproved: result.Task?.IsUatApproved === true,
                        data: {
                            ...prevState.data,
                            IsUatApproved: result.Task?.IsUatApproved === true,
                        },
                    }));
                    this.expandTaskDetailLogs({
                        forceReload: true,
                        scrollIntoView: false,
                    });
                    return;
                }

                notify(result.Message || this.languages.birHataAlındı || "Bir hata alındı", "warning", 3000);
            },
            true,
            () => {
                this.props.actions.isLoading(false);
                this.setState({ uatApprovalSaving: false });
            }
        );
    };

    onToolbarPreparing = (e) => {
        let ths = this;
        let toolbarItems = e.toolbarOptions.items;

        toolbarItems.push({
            widget: "dxButton",
            options: {
                text: this.languages.izleyiciEkle,
                value: this.languages.izleyici,
                color: "success",
                showClearButton: true,
                onClick: function (e) {
                    ths.GetWatcherGroups();
                    ths.GetAllUsersForWatcher();
                    ths.setState({ visibleWatcher: true });
                },
                width: 175,
            },
            location: "after",
        });
    };

    ensurePoolUsersLoadedForResponsibleChange = () => {
        // Havuz kullanıcılarını sorumlu değişim butonuna tıklanınca yükle.
        if (this.poolUsers2Requested || (this.state.poolUsers2 || []).length > 0) {
            return;
        }

        this.poolUsers2Requested = true;
        callAPI(
            callApiGet,
            "/api/TaskTracking/GetMyPoolUsers",
            {},
            (poolUserss) => {
                this.setState({ poolUsers2: poolUserss.data || [] });
            },
            true,
            () => {
                // Hata olursa tekrar denemek için resetliyoruz.
                this.poolUsers2Requested = false;
            }
        );
    };

    onToolbarPreparing2 = (e) => {
        let ths = this;
        let toolbarItems = e.toolbarOptions.items;
        const { isMobile } = this.state;
        toolbarItems.push({
            widget: "dxButton",
            options: {
                text: this.languages.GörevEkle,
                value: this.languages.Görev,
                color: "success",
                showClearButton: true,
                onClick: function (e) {
                    ths.ensurePoolUsersLoadedForResponsibleChange();
                    ths.setState({ visibleJob: true });
                },
                width: isMobile ? 130 : 175,
            },
            location: "after",
        });
    };
    onToolbarPreparing3 = (e) => {
        let ths = this;
        let toolbarItems = e.toolbarOptions.items;
        const { isMobile } = this.state;
        toolbarItems.push({
            widget: "dxButton",
            options: {
                text: this.languages.EkOnayaGönder,
                value: this.languages.EkOnay,
                color: "success",
                showClearButton: true,
                onClick: function (e) {
                    ths.checkAdditionalUserPermission();
                },
                width: isMobile ? 130 : 175,
            },
            location: "after",
        });
    };

    deleteWatcher(Data) {
        BB.askYesNo(
            this.languages.talebintakibibırakılacaktır,
            this.languages.eminMisiniz,
            this.languages.evet,
            this.languages.vazgec,
        ).then((ask) => {
            if (ask === true) {
                BB.FetchJSON(
                    "api/TaskDetail/DeleteWatcherUser?ID=" + Data.WatcherID
                ).then((res) => {
                    BB.FetchJSON(
                        "/api/TaskDetail/GetWatcherUsers?TaskID=" + this.state.taskID
                    ).then((GetWatcherUsers) => {
                        this.setState({ WatcherUsers: GetWatcherUsers });
                    });
                });
            }
        });
    }

    render() {
        const { customElements } = this.state;
        const hiddenCustomControlTypes = [1, 2, 4, 5, 6, 8];
        const normalizePath = (path = "") =>
            decodeURIComponent(path)
                .trim()
                .toLowerCase();

        const customControlPaths = new Set(
            Array.isArray(this.state.data.CustomValue)
                ? this.state.data.CustomValue
                    .filter(x => x.Path) // dosyası olanlar
                    .map(x => normalizePath(x.Path))
                : []
        );

        const { t } = this.props;
        const tooltipId = 'taskOwnerTooltip';
        let { activeTab } = this.state;
        const categoryHistoryRows = this.getCategoryHistoryRows();
        const uatApprovalHistoryRows = this.getUatApprovalHistoryRows();
        const historyTabCount = this.getHistoryTabCount();

        let taskDocuments = [];
        let taskDocumentsName = [];
        const { isMobile } = this.state;
        let taskDescDocuments = [];
        let taskDescDocumentsName = [];

        let taskClosingDocuments = [];
        let taskClosingDocumentsName = [];
        const DATE_OPTIONS = {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
        };
        const openedOnBehalfOfAnother =
            this.state.data?.OwnerUser &&
            this.state.data?.CreateUser &&
            this.state.data?.OwnerUserID &&
            this.state.data?.CreateUserID &&
            String(this.state.data.OwnerUserID) !== String(this.state.data.CreateUserID);


        if (
            this.props.location.state !== undefined ||
            this.props.location.search !== undefined
        ) {
            if (this.state.data.length !== 0) {
                if (this.state.data.TaskDocument.length > 0) {
                    for (let i = 0; i < this.state.data.TaskDocument.length; i++) {
                        let currentDocument = this.state.data.TaskDocument[i];

                        if (currentDocument.Document.DocumentType === "1") {
                            taskDocuments.push(currentDocument);
                            // FilePath null kontrolü - erişim süresi geçmişse null olabilir
                            if (currentDocument.Document.FilePath) {
                                taskDocumentsName.push(
                                    currentDocument.Document.FilePath.toString().split("/")[
                                    currentDocument.Document.FilePath.toString().split("/")
                                        .length - 1
                                    ]
                                );
                            } else {
                                taskDocumentsName.push("Erişim süresi geçmiştir");
                            }
                        }
                        if (currentDocument.Document.DocumentType === "2") {
                            taskDescDocuments.push(currentDocument);
                            // FilePath null kontrolü - erişim süresi geçmişse null olabilir
                            if (currentDocument.Document.FilePath) {
                                taskDescDocumentsName.push(
                                    currentDocument.Document.FilePath.toString().split("/")[
                                    currentDocument.Document.FilePath.toString().split("/")
                                        .length - 1
                                    ]
                                );
                            } else {
                                taskDescDocumentsName.push("Erişim süresi geçmiştir");
                            }
                        }
                        if (currentDocument.Document.DocumentType === "3") {
                            taskClosingDocuments.push(currentDocument);
                            // FilePath null kontrolü - erişim süresi geçmişse null olabilir
                            if (currentDocument.Document.FilePath) {
                                taskClosingDocumentsName.push(
                                    currentDocument.Document.FilePath.toString().split("/")[
                                    currentDocument.Document.FilePath.toString().split("/")
                                        .length - 1
                                    ]
                                );
                            } else {
                                taskClosingDocumentsName.push("Erişim süresi geçmiştir");
                            }
                        }
                    }
                }

                return (
                    <Row>
                        <Col lg={12}>
                            <Row>
                                <Col xs="12" sm="3">
                                    <Card
                                        className="text-center"
                                        style={{
                                            height: this.renderActionButtons() ? "auto" : 84,
                                            marginBottom: this.renderActionButtons() ? "auto" : 0,
                                        }}
                                    >
                                        <CardBody>{this.renderActionButtons()}</CardBody>
                                    </Card>
                                </Col>

                                <Col xs="12" sm="6">
                                    <Card style={{ backgroundColor: "beige" }}>
                                        <CardBody>
                                            <Row>
                                                <Col>
                                                    <Row style={{ marginLeft: 0 }}>
                                                        <strong>{t("talepDurumu")}</strong>
                                                    </Row>
                                                    <Row style={{ marginLeft: 0 }}>
                                                        {this.state.data.StatusName != null ? this.state.data.StatusName.toString() : this.state.data.StatusName}
                                                    </Row>
                                                </Col>
                                                <Col>
                                                    {this.state.loginUser.ID ===
                                                        this.state.data.ResponsibleUserID ? (
                                                        !this.state.data.TerminationDate ? (
                                                            <Button
                                                                style={{
                                                                    width: 100,
                                                                    float: "right",
                                                                    marginTop: 5,
                                                                }}
                                                                outline
                                                                color="danger"
                                                                onClick={() => this.taskActions("sonlandir")}
                                                            >
                                                                {t("sonlandır")}
                                                            </Button>
                                                        ) : null
                                                    ) : null}
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>

                                <Col xs="12" sm="3">
                                    <Card style={{ backgroundColor: "azure" }}>
                                        <CardBody>
                                            <Row>
                                                <Col sm={8}>
                                                    <Row style={{ marginLeft: 0 }}>
                                                        <strong>{t("islemdurum")}</strong>
                                                    </Row>
                                                    <Row style={{ marginLeft: 0 }}>
                                                        {this.state.data.WorkStatus.Name
                                                            ? this.state.data.WorkStatus.Name
                                                            : t("İşlemDurumuSeçilideğil")}
                                                        {/* {this.state.status.filter(statu => statu.ID === this.state.data.WorkStatusID).length > 0 ? this.state.status.filter(statu => statu.ID === this.state.data.WorkStatusID)[0].Name : 'İşlem durumu seçili değil'} */}
                                                    </Row>
                                                </Col>
                                                <Col sm={4}>
                                                    {this.state.loginUser.ID ===
                                                        this.state.data.ResponsibleUserID ? (
                                                        !this.state.data.TerminationDate ? (
                                                            <Button
                                                                block
                                                                outline
                                                                color={
                                                                    this.state.data.WorkStatusID !==
                                                                        "b22df37b-8ac8-e811-80f6-005056b839bb"
                                                                        ? this.state.data.WorkStatusID !== null
                                                                            ? "success"
                                                                            : "primary"
                                                                        : "primary"
                                                                }
                                                                onClick={() =>
                                                                    this.taskActions("durumDegistir")
                                                                }
                                                            >
                                                                {this.state.data.WorkStatusID !==
                                                                    "b22df37b-8ac8-e811-80f6-005056b839bb"
                                                                    ? this.state.data.WorkStatusID !== null
                                                                        ? t("islemeAl")
                                                                        : t("durumdeğiştir")
                                                                    : t("durumdeğiştir")}
                                                            </Button>
                                                        ) : null
                                                    ) : null}
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs="12" sm="3">
                                    <CustomCard cardStyle="card-dashboard-calendar pb-0">
                                        <LabelGroup
                                            title={t("ozet")}
                                            description={t("talebinOzetBilgisi")}
                                        />
                                        <Row>
                                            <Col xs="4" sm="4">
                                                <strong>{t("talepno")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="6">
                                                {this.state.data.TaskNumber ||
                                                    this.state.data.taskNumber ||
                                                    ""}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="4" sm="4">
                                                <strong>{t("açılış")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="6">
                                                {(() => {
                                                    const raw = this.getTaskCreateDateRaw();
                                                    if (raw == null) return "";
                                                    const dt = new Date(raw);
                                                    if (Number.isNaN(dt.getTime())) return "";
                                                    return (
                                                        dt.toLocaleDateString() + " " + dt.toLocaleTimeString()
                                                    );
                                                })()}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="4" sm="4">
                                                <strong>{t("sahibi")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="6">
                                                <span
                                                    data-tip=
                                                    {this.state.data?.CreateUser?.Name +
                                                        " " +
                                                        this.state.data?.CreateUser?.SurName}
                                                    data-for={tooltipId}>
                                                    {this.state.data?.CreateUser?.Name +
                                                        " " +
                                                        this.state.data?.CreateUser?.SurName}
                                                </span>
                                                <ReactTooltip id={tooltipId} place="top" effect="solid">
                                                    <div>{this.state.data.CreateUser.UserName}</div>
                                                </ReactTooltip>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="4" sm="4">
                                                <strong>{"Email"}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="6">
                                                <span>
                                                    {this.state.data.RequesterEmail == null ? this.state.data.CreateUser.Email : this.state.data.RequesterEmail}
                                                </span>

                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="4" sm="4">
                                                <strong>{t("kurum")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="6">
                                                {this.state.data.CreateUser.CompanyName}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="4" sm="4">
                                                <strong>{t("gsm")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            {this.state.data.CreateUser.MobilPhone === null ? (
                                                <Col xs="6" sm="6">
                                                    {this.state.data.CreateUser.Phone}
                                                </Col>
                                            ) : this.state.data.CreateUser.Phone === null ? (
                                                <Col xs="6" sm="6">
                                                    {" "}
                                                    {this.state.data.CreateUser.MobilPhone}{" "}
                                                </Col>
                                            ) : (
                                                <Col xs="6" sm="6">
                                                    {" "}
                                                    {this.state.data.CreateUser.MobilPhone +
                                                        " / " +
                                                        this.state.data.CreateUser.Phone}{" "}
                                                </Col>
                                            )}
                                        </Row>
                                        <Row>
                                            <Col xs="4" sm="4">
                                                <strong>
                                                    {t("talepkategorisi")}{" "}
                                                    <i
                                                        className="fa fa-refresh"
                                                        onClick={() => {
                                                            this.checkChangeCategoryAccept(this.state.taskID, () => {
                                                                this.getCategoriesForChangeCategories();
                                                                this.setState({
                                                                    changeCategoryModalVisible: true,
                                                                });
                                                            });
                                                        }}
                                                        aria-hidden="true"
                                                        style={{
                                                            marginLeft: 8,
                                                            display: this.state.iconCategoryVisible,
                                                        }}
                                                    ></i>
                                                </strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="6">
                                                {this.state.data.CategoryTree ||
                                                    this.state.data.Category?.CategoryName ||
                                                    this.state.data.Category?.Name ||
                                                    ""}
                                            </Col>
                                        </Row>
                                        {this.state.data.ResponsibleUser ? (
                                            <Row>
                                                <Col xs="4" sm="4">
                                                    <strong>{t("talepsorumlusu")}</strong>
                                                </Col>
                                                <Col xs="1" sm="1">
                                                    :
                                                </Col>
                                                <Col xs="6" sm="6">
                                                    {this.state.data.ResponsibleUser.Name}{" "}
                                                    {this.state.data.ResponsibleUser.SurName}
                                                    <i
                                                        className="fa fa-refresh"
                                                        onClick={() => {
                                                            this.ensurePoolUsersLoadedForResponsibleChange();
                                                            this.setState({ takeOverUserVisible: true });
                                                        }}
                                                        aria-hidden="true"
                                                        style={{
                                                            marginLeft: 8,
                                                            display: this.state.iconVisible,
                                                        }}
                                                    ></i>
                                                </Col>
                                            </Row>
                                        ) : null}

                                        <Row>
                                            <Col xs="4" sm="4">
                                                <strong>{t("sla")}</strong>
                                            </Col>

                                            <Col xs="1" sm="1">
                                                :
                                            </Col>

                                            <Col xs="6" sm="6">
                                                {this.state.data.SlaMinute ?? this.state.data.Category?.SLA}
                                            </Col>

                                        </Row>
                                        <Row>
                                            <Col xs="4" sm="4">
                                                <strong>{t("Efor")}</strong>
                                            </Col>

                                            <Col xs="1" sm="1">
                                                :
                                            </Col>

                                            <Col xs="4" sm="4">

                                                {BB.InputWithoutLabelEffort(
                                                    "effor",
                                                    "text",
                                                    this,
                                                    false
                                                )}

                                            </Col>

                                            <Col xs="1" sm="1">
                                                <i
                                                    className="fa fa-check"
                                                    onClick={() => {
                                                        this.changeEffort()
                                                    }}
                                                    aria-hidden="true"
                                                    style={{
                                                        display: this.state.iconVisible,
                                                    }}
                                                ></i>
                                            </Col>

                                        </Row>
                                        {this.state.data.ExpectedEndDate ? (
                                            <Row>
                                                <Col xs="4" sm="4">
                                                    <strong>{t("tahminibitiştarihi")}</strong>
                                                </Col>
                                                <Col xs="1" sm="1">
                                                    :
                                                </Col>
                                                <Col xs="6" sm="6">
                                                    {new Date(
                                                        this.state.data.ExpectedEndDate
                                                    ).toLocaleDateString()}
                                                </Col>
                                            </Row>
                                        ) : null}

                                        {this.state.data.TaskConfirmation
                                            ? this.state.data.TaskConfirmation.length > 0
                                                ? this.state.data.TaskConfirmation.ProcurationUserID !==
                                                    null
                                                    ? this.state.data.TaskConfirmation.map((item, i) => {
                                                        return (
                                                            <div key={i}>
                                                                <Row style={{ marginLeft: -15 }}>
                                                                    <Col xs="4" sm="4">
                                                                        <strong>{i + 1}.{t("Onay")}</strong>
                                                                    </Col>
                                                                    <Col xs="1" sm="1">
                                                                        :
                                                                    </Col>
                                                                    <Col xs="6" sm="6">
                                                                        {item.User.Name} {item.User.SurName}{" "}
                                                                        {item.ProcurationUserID !== null
                                                                            ? "VEK. " +
                                                                            item.ProcurationUser.Name +
                                                                            " " +
                                                                            item.ProcurationUser.SurName
                                                                            : ""}
                                                                    </Col>
                                                                </Row>

                                                                {item.ApprovalDate !== null && (
                                                                    <Row style={{ marginLeft: -15 }}>
                                                                        <Col xs="4" sm="4">
                                                                            <strong>{i + 1}.{t("OnayTarihi")}</strong>
                                                                        </Col>
                                                                        <Col xs="1" sm="1">
                                                                            :
                                                                        </Col>
                                                                        <Col xs="6" sm="6">
                                                                            {new Date(
                                                                                item.ApprovalDate
                                                                            ).toLocaleDateString() +
                                                                                " " +
                                                                                new Date(
                                                                                    item.ApprovalDate
                                                                                ).toLocaleTimeString()}
                                                                        </Col>
                                                                    </Row>
                                                                )}
                                                            </div>
                                                        );
                                                    })
                                                    : this.state.data.TaskConfirmation.map((item, i) => {
                                                        return (
                                                            <div key={i}>
                                                                <Row style={{ marginLeft: -15 }}>
                                                                    <Col xs="4" sm="4">
                                                                        <strong>{i + 1}.{t("Onay")}</strong>
                                                                    </Col>
                                                                    <Col xs="1" sm="1">
                                                                        :
                                                                    </Col>
                                                                    <Col xs="6" sm="6">
                                                                        {item.User.Name} {item.User.SurName}
                                                                    </Col>
                                                                </Row>
                                                                {item.ApprovalDate !== null && (
                                                                    <Row style={{ marginLeft: -15 }}>
                                                                        <Col xs="4" sm="4">
                                                                            <strong>{i + 1}.{t("OnayTarihi")}</strong>
                                                                        </Col>
                                                                        <Col xs="1" sm="1">
                                                                            :
                                                                        </Col>
                                                                        <Col xs="6" sm="6">
                                                                            {new Date(
                                                                                item.ApprovalDate
                                                                            ).toLocaleDateString() +
                                                                                " " +
                                                                                new Date(
                                                                                    item.ApprovalDate
                                                                                ).toLocaleTimeString()}
                                                                        </Col>
                                                                    </Row>
                                                                )}
                                                            </div>
                                                        );
                                                    })
                                                : null
                                            : null}

                                        {/* {this.state.additionalUsersForTask.map((item,i)=>{
                            return (<div key={i}>
                              <Row style={{ marginLeft: -15 }}>
                                <Col xs="4" sm="4">
                                  <strong>{i + 1}.Ek Onay</strong>
                                </Col>
                                <Col xs="1" sm="1">
                                  :
                                </Col>
                                <Col xs="6" sm="6">
                                  {item.Name} {item.SurName}
                                </Col>
                              </Row>
                              {item.ApprovalDate !== null && (
                                <Row style={{ marginLeft: -15 }}>
                                  <Col xs="4" sm="4">
                                    <strong>{i + 1}.Ek Onay Tarihi</strong>
                                  </Col>
                                  <Col xs="1" sm="1">
                                    :
                                  </Col>
                                  <Col xs="6" sm="6">
                                    {new Date(
                                      item.ApprovalDate
                                    ).toLocaleDateString() +
                                      " " +
                                      new Date(
                                        item.ApprovalDate
                                      ).toLocaleTimeString()}
                                  </Col>
                                </Row>
                              )}
                            </div>)

                          })} */}

                                        {openedOnBehalfOfAnother && (
                                            <Row style={{ marginTop: 10, color: "chocolate" }}>
                                                <Col>
                                                    <i className={"icon-info"}></i>
                                                    {" Bu Talep "}{" "}
                                                    {this.state.data?.CreateUser?.Name +
                                                        " " +
                                                        this.state.data?.CreateUser?.SurName}{" "}
                                                    {" Adına "}
                                                    {this.state.data.OwnerUser.Name +
                                                        " " +
                                                        this.state.data.OwnerUser.SurName}
                                                    {" Tarafından açılmıştır"}
                                                </Col>
                                            </Row>
                                        )}
                                        {this.state.data.MainTaskID && (
                                            <Row style={{ marginTop: 10, color: "chocolate" }}>
                                                <Col>
                                                    <i className={"icon-info"}></i>
                                                    {" Bu Talep "}
                                                    <a
                                                        href={"#!/TaskDetail?" + this.state.data.MainTaskID}
                                                        target="_blank"
                                                    >
                                                        {this.state.data?.MainTask?.TaskNumber || "İş tekrarı talebi"}
                                                    </a>
                                                    {" numaralı talebin iş tekrarı olarak açılmıştır"}
                                                </Col>
                                            </Row>
                                        )}
                                    </CustomCard>
                                </Col>

                                <Col xs="12" sm="6">
                                    <CustomCard cardStyle="card-dashboard-calendar pb-0">
                                        {((Array.isArray(this.state.customFormData) && this.state.customFormData.length > 0) ||
                                            Number(this.state?.tabCounts?.forms || 0) > 0) && (
                                                <div className="card-header-actions">
                                                    <Button
                                                        style={{
                                                            width: 170,
                                                            backgroundColor: "darkseagreen",
                                                        }}
                                                    >
                                                        <Row
                                                            style={{ justifyContent: "center" }}
                                                            onClick={() => this.taskActions("formGoruntule")}
                                                        >
                                                            {t("formlar")}
                                                        </Row>
                                                    </Button>
                                                </div>
                                            )}

                                        {((Array.isArray(this.state.customSheetData) && this.state.customSheetData.length > 0) ||
                                            Number(this.state?.tabCounts?.sheets || 0) > 0) && (
                                                <div className="card-header-actions">
                                                    <Button
                                                        style={{
                                                            width: 140,
                                                            backgroundColor: "darkseagreen",
                                                            marginRight: 10,
                                                        }}
                                                    >
                                                        <Row
                                                            style={{ justifyContent: "center" }}
                                                            onClick={() => this.taskActions("sheetGoruntule")}
                                                        >
                                                            {t("tablolar")}
                                                        </Row>
                                                    </Button>
                                                </div>
                                            )}
                                        <Row className="align-items-start">
                                            <Col xs="8">
                                                <LabelGroup
                                                    title={t("ekbilgi")}
                                                    description={t("Talebeaittemelbilgilerburadayeralmaktadır")}
                                                />
                                            </Col>

                                            {((Array.isArray(this.state.data.CustomValue) &&
                                                this.state.data.CustomValue.length > 0) ||
                                                Number(this.state?.tabCounts?.extraInfo || 0) > 0) && (
                                                    <Col
                                                        xs="4"
                                                        className="text-right"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            marginTop: "-6px"
                                                        }}
                                                    >
                                                        <button
                                                            className="btn btn-outline-primary btn-sm"
                                                            style={{
                                                                backgroundColor: "#ffc107",
                                                                color: "#333",
                                                                border: "1px solid #ffc107",
                                                                fontWeight: 600,
                                                                padding: "7px 14px",
                                                                borderRadius: "8px"
                                                            }}
                                                            onClick={this.openExtraInfoModal}
                                                        >
                                                            Talebe ait ek bilgiler
                                                        </button>
                                                    </Col>
                                                )}
                                        </Row>

                                        <DropdownItem divider />


                                        <Row>
                                            <Col xs="4" sm="3">
                                                <strong>{t("talepAciklamasi")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="8">
                                                {ReactHtmlParser(
                                                    this.state.data.HTMLDescription
                                                        ? this.state.data.HTMLDescription
                                                        : this.state.data.Description
                                                )}
                                            </Col>
                                        </Row>
                                        <DropdownItem divider />
                                        <Row>
                                            <Col xs="4" sm="3">
                                                <strong>{t("aciliyet")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="8">
                                                {this.state.data.DegreeOfUrgency === 0
                                                    ? t("düşük")
                                                    : this.state.data.DegreeOfUrgency === 1
                                                        ? t("orta")
                                                        : t("yüksek")}
                                            </Col>
                                        </Row>
                                        <DropdownItem divider />
                                        <Row>
                                            <Col xs="4" sm="3">
                                                <strong>{t("aciliyetaçıklaması")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="8">
                                                {this.state.data.UrgencyDescription}
                                            </Col>
                                        </Row>

                                        {this.state.data.Effect !== null && (
                                            <>
                                                <DropdownItem divider />
                                                <Row>
                                                    <Col xs="4" sm="3">
                                                        <strong>{t("etki")}</strong>
                                                    </Col>
                                                    <Col xs="1" sm="1">
                                                        :
                                                    </Col>
                                                    <Col xs="6" sm="8">
                                                        {this.state.data.Effect.Name}
                                                    </Col>
                                                </Row>
                                            </>
                                        )}

                                        <DropdownItem divider />

                                        <Row>
                                            <Col xs="4" sm="3">
                                                <strong>{t("talepbelgeleri")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="8">
                                                {(() => {
                                                    const normalize = (v = "") =>
                                                        decodeURIComponent(v)
                                                            .toLowerCase()
                                                            .replace(/[\s_-]/g, "")
                                                            .replace(/ı/g, "i")
                                                            .replace(/ğ/g, "g")
                                                            .replace(/ü/g, "u")
                                                            .replace(/ş/g, "s")
                                                            .replace(/ö/g, "o")
                                                            .replace(/ç/g, "c");

                                                    // CustomValue içinden sadece FILE upload (CustomControlType===2) alanlarını al
                                                    const customUploadValues = Array.isArray(
                                                        this.state.data.CustomValue
                                                    )
                                                        ? this.state.data.CustomValue.filter((x) => {
                                                            const t =
                                                                x?.CategoryCustomControl
                                                                    ?.CustomControlType;
                                                            return x?.Value && Number(t) === 2;
                                                        })
                                                        : [];

                                                    const customFiles = new Set(
                                                        customUploadValues.map((x) =>
                                                            normalize(x.Value)
                                                        )
                                                    );

                                                    return taskDocuments.map((item, i) => {
                                                        const fileName = getCleanFileName(item.Document.FilePath);
                                                        const normalized = normalize(fileName);
                                                        const isMatch = customFiles.has(normalized);

                                                        // Eğer bu dosya custom upload ise talep belgelerinde gösterme
                                                        if (isMatch) {
                                                            return null;
                                                        }

                                                        return createSecureDownloadLink(
                                                            item.Document,
                                                            fileName,
                                                            {
                                                                key: i,
                                                                style: { marginRight: 10 }
                                                            },
                                                            fileName
                                                        );
                                                    });
                                                })()}
                                            </Col>
                                        </Row>
                                        {this.state.data.CustomValue.length > 0 &&
                                            this.state.data.CustomValue.map((item, i) => {
                                                const itemTypeRaw =
                                                    item?.CategoryCustomControl?.CustomControlType;
                                                const itemType = Number(itemTypeRaw);
                                                if (
                                                    Number.isNaN(itemType) ||
                                                    hiddenCustomControlTypes.includes(itemType) ||
                                                    itemType === 2
                                                ) {
                                                    return null;
                                                }
                                                return (
                                                    <div key={i}>
                                                        <DropdownItem divider />
                                                        <Row>
                                                            <Col xs="4" sm="3">
                                                                <strong style={{ color: "cadetblue" }}>
                                                                    {item.CategoryCustomControl.Value + " : "}
                                                                </strong>
                                                            </Col>
                                                            <Col xs="1" sm="1">
                                                                :
                                                            </Col>
                                                            <Col xs="6" sm="8">
                                                                {itemType === 1
                                                                    ? new Date(item.Value).toLocaleDateString(
                                                                        "tr-TR",
                                                                        DATE_OPTIONS
                                                                    )
                                                                    : item.Value}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                );
                                                // }
                                            })}

                                        <DropdownItem divider />
                                        <Row>
                                            <Col xs="4" sm="3">
                                                <strong>{t("kapanışbelgeleri")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="8">
                                                {taskClosingDocuments.map((item, i) => {
                                                    const fileName = getCleanFileName(item.Document.FilePath);
                                                    return createSecureDownloadLink(
                                                        item.Document,
                                                        fileName,
                                                        {
                                                            key: i,
                                                            style: { marginRight: 10 }
                                                        },
                                                        fileName
                                                    );
                                                })}
                                            </Col>
                                        </Row>
                                        <DropdownItem divider />
                                        <Row>
                                            <Col xs="4" sm="3">
                                                <strong>{t("kapanışmesajı")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="6" sm="8">
                                                {this.state.data.TerminationDescription}
                                            </Col>
                                        </Row>

                                        <DropdownItem divider />
                                        <Row>
                                            <Col xs="4" sm="3">
                                                <strong>{t("projeNumarası")}</strong>
                                            </Col>
                                            <Col xs="1" sm="1">
                                                :
                                            </Col>
                                            <Col xs="3" sm="3">
                                                {BB.InputWithoutLabelProjectNumber(
                                                    "selectedProjectNumber",
                                                    "text",
                                                    this,
                                                    false
                                                )}
                                            </Col>
                                            <Col xs="5" sm="5">
                                                <Button
                                                    style={{ float: "right", marginTop: 6 }}
                                                    color={"info"}
                                                    outline
                                                    onClick={this.changeProjectNumber}
                                                >
                                                    {t("kaydet")}
                                                </Button>
                                                {/* {BB.TextAreaWithLabel('selectedDegreeOfUrencyDesc', t('açıklama'), '', 5, this)} */}
                                            </Col>
                                        </Row>
                                        {this.state.data?.IsUatApprovalVisible === true && (
                                            <>
                                                <DropdownItem divider />
                                                <Row>
                                                    <Col xs="4" sm="3">
                                                        <strong>UAT Onayı Alınmıştır</strong>
                                                    </Col>
                                                    <Col xs="1" sm="1">
                                                        :
                                                    </Col>
                                                    <Col xs="3" sm="3" style={{ marginTop: 6 }}>
                                                        <Input
                                                            type="checkbox"
                                                            id="selectedIsUatApproved"
                                                            checked={this.state.selectedIsUatApproved === true}
                                                            disabled={this.state.uatApprovalSaving}
                                                            onChange={() =>
                                                                this.handleChange("selectedIsUatApproved")
                                                            }
                                                        />
                                                    </Col>
                                                    <Col xs="5" sm="5">
                                                        <Button
                                                            style={{ float: "right", marginTop: 6 }}
                                                            color={"info"}
                                                            outline
                                                            disabled={this.state.uatApprovalSaving}
                                                            onClick={this.updateUatApproval}
                                                        >
                                                            {t("kaydet")}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    </CustomCard>
                                </Col>

                                {/* <Col xs="12" sm="3">
                  <CustomCard
                    cardStyle="card-dashboard-calendar pb-0"
                    isTaskDetail={true}
                  >
                    <LabelGroup
                      title={t("Açık Talepler")}
                      description={"Havuzdaki Diğer Talepler"}
                    />

                    <div style={{ height: 313, overflowY: "scroll" }}>
                      {this.props.poolTasks.map((item, i) => {
                        return (
                          <Col
                            style={{
                              backgroundColor: "ghostwhite",
                              cursor: "pointer",
                              zIndex: 0,
                            }}
                            key={i}
                            onClick={() => this.getData(item.ID)}
                          >
                            <Row className="d-flex justify-content-between">
                              <Col style={{ marginTop: 10 }}>
                                <strong>{"#" + item.TaskNumber}</strong>{" "}
                                {" - " + item.CategoryName}
                              </Col>
                            </Row>
                            <Row>
                              <Col style={{ textAlign: "start" }}>
                                {"Aciliyet : " + item.DegreeOfUrgencyStr}
                              </Col>
                            </Row>
                            <Row>
                              <Col style={{ textAlign: "start" }}>
                                {"Oluşturan : " + item.CreateUserName}
                              </Col>
                            </Row>
                            <hr />
                          </Col>
                        );
                      })}
                    </div>
                  </CustomCard>
                </Col> */}
                            </Row>

                            <Row>
                                <Col xs="12" sm="12" xl={12}>
                                    <div ref={this.taskDetailLogsAnchorRef}>
                                        <CustomCard>
                                            <div className="table-task-div" style={{ marginTop: 0 }}>
                                                <Row>
                                                        <Col xl={8}>
                                                            <Nav tabs>
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classNames({
                                                                            active: activeTab === "1",
                                                                        })}
                                                                        onClick={() => this.changeTab("1")}
                                                                    >
                                                                        {t("aciklamalar")}
                                                                        {this.state.taskLogDescription.length > 0 && (
                                                                            <Badge
                                                                                pill
                                                                                color="success"
                                                                                style={{
                                                                                    top: -8,
                                                                                    position: "absolute",
                                                                                }}
                                                                            >
                                                                                {this.state.taskLogDescription.length}
                                                                            </Badge>
                                                                        )}
                                                                    </NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classNames({
                                                                            active: activeTab === "2",
                                                                        })}
                                                                        onClick={() => this.changeTab("2")}
                                                                    >
                                                                        {t("talephareketleri")}
                                                                    </NavLink>
                                                                </NavItem>
                                                                {/* <div style={display="none"}> */}
                                                                <NavItem
                                                                    style={{
                                                                        display: this.state.isLastUser,
                                                                    }}
                                                                >
                                                                    <NavLink
                                                                        className={classNames({
                                                                            active: activeTab === "3",
                                                                        })}
                                                                        onClick={() => this.changeTab("3")}
                                                                    >
                                                                        {t("gorevler")}


                                                                        {(this.state.jobsLoaded
                                                                            ? this.state.myJobs.length
                                                                            : this.state.tabCounts.jobs) > 0 && (
                                                                            <Badge
                                                                                pill
                                                                                color="warning"
                                                                                style={{
                                                                                    top: -8,
                                                                                    position: "absolute",
                                                                                }}
                                                                            >
                                                                                {this.state.jobsLoaded
                                                                                    ? this.state.myJobs.length
                                                                                    : this.state.tabCounts.jobs}
                                                                            </Badge>
                                                                        )}
                                                                    </NavLink>
                                                                </NavItem>
                                                                {/* </div> */}
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classNames({
                                                                            active: activeTab === "4",
                                                                        })}
                                                                        onClick={() => this.changeTab("4")}
                                                                    >
                                                                        {t("talepHareketleri")}
                                                                        {(this.state.recentlyViewedLoaded
                                                                            ? this.state.recentlyViewed.length
                                                                            : this.state.tabCounts.recentlyViewed) > 0 && (
                                                                            <Badge
                                                                                pill
                                                                                color="warning"
                                                                                style={{
                                                                                    top: -8,
                                                                                    position: "absolute",
                                                                                }}
                                                                            >
                                                                                {this.state.recentlyViewedLoaded
                                                                                    ? this.state.recentlyViewed.length
                                                                                    : this.state.tabCounts.recentlyViewed}
                                                                            </Badge>
                                                                        )}
                                                                    </NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classNames({
                                                                            active: activeTab === "5",
                                                                        })}
                                                                        onClick={() => this.changeTab("5")}
                                                                    >
                                                                        {t("izleyiciler")}
                                                                        {(this.state.watcherUsersLoaded
                                                                            ? this.state.WatcherUsers.length
                                                                            : this.state.tabCounts.watchers) > 0 && (
                                                                            <Badge
                                                                                pill
                                                                                color="warning"
                                                                                style={{
                                                                                    top: -8,
                                                                                    position: "absolute",
                                                                                }}
                                                                            >
                                                                                {this.state.watcherUsersLoaded
                                                                                    ? this.state.WatcherUsers.length
                                                                                    : this.state.tabCounts.watchers}
                                                                            </Badge>
                                                                        )}
                                                                    </NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classNames({
                                                                            active: activeTab === "6",
                                                                        })}
                                                                        onClick={() => this.changeTab("6")}
                                                                    >
                                                                        Tarihçe
                                                                        {historyTabCount > 0 && (
                                                                            <Badge
                                                                                pill
                                                                                color="info"
                                                                                style={{
                                                                                    top: -8,
                                                                                    position: "absolute",
                                                                                }}
                                                                            >
                                                                                {historyTabCount}
                                                                            </Badge>
                                                                        )}
                                                                    </NavLink>
                                                                </NavItem>
                                                            </Nav>
                                                        </Col>
                                                        <Col xl={4}>
                                                            <div
                                                                style={{
                                                                    float: "right",
                                                                }}
                                                            >
                                                                <Button
                                                                    style={{ backgroundColor: "aliceblue" }}
                                                                    onClick={() => this.taskActions("aciklamaekle")}
                                                                >
                                                                    {t("aciklamaDosyaEkle")}
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col>
                                                            <TabContent
                                                                activeTab={activeTab}
                                                                style={{ marginTop: 0 }}
                                                            >
                                                                <TabPane tabId="1">
                                                                    {BB.DxDataGridForTaskLogDescription(
                                                                        this.state.taskLogDescription,
                                                                        this,
                                                                        isMobile
                                                                    )}
                                                                </TabPane>

                                                                <TabPane tabId="2">
                                                                    {BB.DxDataGridForTaskLog(
                                                                        this.state.taskLog,
                                                                        this,
                                                                        isMobile
                                                                    )}
                                                                </TabPane>

                                                                <TabPane tabId="3">
                                                                    {BB.DxDataGridJobs(this.state.myJobs, this, isMobile)}

                                                                    {/* <Jobs
                                  taskID={this.state.taskID}
                                  isTaskDetail={true}
                              /> */}
                                                                </TabPane>

                                                                <TabPane tabId="4">
                                                                    {BB.DxDataGridRecentlyViewed(
                                                                        this.state.recentlyViewed,
                                                                        this
                                                                    )}
                                                                </TabPane>

                                                                <TabPane tabId="5">
                                                                    {BB.DxDataGridWatcherUsers(
                                                                        this.state.WatcherUsers,
                                                                        this,
                                                                        this.state.loginUser,
                                                                        isMobile
                                                                    )}
                                                                </TabPane>
                                                                <TabPane tabId="6">
                                                                    {uatApprovalHistoryRows.length > 0 &&
                                                                        BB.DxDataGridForUatApprovalHistory(
                                                                            uatApprovalHistoryRows,
                                                                            this,
                                                                            isMobile
                                                                        )}
                                                                    {categoryHistoryRows.length > 0 &&
                                                                        BB.DxDataGridForCategoryHistory(
                                                                            categoryHistoryRows,
                                                                            this,
                                                                            isMobile
                                                                        )}
                                                                    {historyTabCount === 0 && (
                                                                        <div style={{ padding: "12px 4px" }}>
                                                                            {t("kayitBulunamadi") || "Kayıt bulunamadı."}
                                                                        </div>
                                                                    )}
                                                                </TabPane>
                                                            </TabContent>
                                                        </Col>
                                                </Row>
                                            </div>
                                        </CustomCard>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <ExtraInfoModal
                            open={this.state.extraInfoVisible}
                            onClose={() => this.setState({ extraInfoVisible: false })}
                            data={this.state.extraInfoData}
                            taskDocuments={taskDocuments}
                        />
                        <ExtraInfoModal
                            open={this.state.showExtraInfoModal}
                            onClose={() => this.setState({ showExtraInfoModal: false })}
                            data={Array.isArray(this.state.data.CustomValue) ? this.state.data.CustomValue : []}
                            taskDocuments={taskDocuments}
                        />
                        <AdditionalDescription t={t} event={this} />

                        <TaskUpdateDescription t={t} event={this} />

                        <TaskChangeUrgencyModal t={t} event={this} />

                        <TaskTerminationModal t={t} event={this} />

                        <AddJobModal t={t} event={this} />

                        <TaskTransferModal t={t} event={this} />

                        <TaskAddWatcher t={t} event={this} />

                        <TaskViewDescription event={this} />

                        <TaskAddDescription t={t} event={this} />

                        <TaskChangeProcessStatus t={t} event={this} />

                        <TaskViewForm t={t} event={this} />

                        <TaskViewSheet t={t} event={this} />

                        <TakeOverUser t={t} event={this} />
                        <AdditionalConfirmationModal t={t} event={this} />

                        <ChangeCategoryByTask t={t} event={this} />
                    </Row>
                );
            } else {
                return (
                    <div className="animated fadeIn pt-1 text-center">{t("yukleniyor")}</div>
                );
            }
        } else {
            if (
                this.state.loginUser.Role !== "d45342ab-14d1-e811-80f6-005056b839bb"
            ) {
                return <Redirect push to="/TaskTracking" />;
            } else {
                return <Redirect push to="/OwnTask" />;
            }
        }
    }
}
function mapStateToProps(state) {
    return {
        tasks: state.taskReducer,
        loginUser: state.loginReducer,
        poolTasks: state.poolReducer,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            //getPoolTaskCount: bindActionCreators(poolActions.getPoolCount, dispatch),
            isLoading: bindActionCreators(loadingActions.setLoading, dispatch),
        },
    };
}

export default withRouter(
    withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TaskDetail))
);
